<div class="bg-th-blue mt-0 container-fluid py-2">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" [routerLink]="getBackUrl()"></i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center">

            {{title | faNum}}

            <span class="fw-bold mx-2" *ngIf="type == 2 && reportData[0]?.strFullName">

                ( {{reportData[0]?.strFullName + ' ** ' + reportData[0]?.strVehicleNo | faNum}} )

            </span>

            <i *ngIf="guidId && type !== 2" style="font-size: 30px;" class="fa fa-question-circle me-2  pointer"
                (click)="guid()">

            </i>

        </a>

    </div>

</div>

<div class="col-12 d-flex justify-content-center" *ngIf="type==8">
    <div class="col-8  mt-3">
        <input type="text" class="form-control dirI" placeholder="جستجو نام ورودی" (keyup)="filter($event.target)">
    </div>
</div>

<div class="col-12 d-flex justify-content-around dirI flex-wrap" *ngIf="type==14">
    <div class="col-md-3 col-5  mt-3">
        <form [formGroup]="dataStart">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </form>
    </div>
    <div class="col-md-3 col-5  mt-3">
        <form [formGroup]="dataEnd">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </form>
    </div>
    <div class="col-md-5 col-12  mt-3 d-flex justify-content-around flex-wrap">
        <div class="col-12 col-md-7 d-flex flex-wrap justify-content-around flex-row">
            <button class="btn btn-primary" (click)="searchSalery('Mobile_GetSalari')">جستجو</button>
            <button class="btn btn-success" *ngIf="acssess.bSalariEdit"
                (click)="searchSalery('Mobile_ReCalSalari')">محاسبه مجدد</button>
            <input type="file" accept=".xlsx" class="d-none" id="exelUpload" (change)="fileChange($event)">
            <button class="btn btn-info btn-sm" *ngIf="acssess.bMobileImportTimesheet" (click)="openUploder()">بارگزاری
                کارکرد از اکسل</button>
        </div>
        <div class="col-12 col-md-5 d-flex justify-content-around flex-row mt-2 mt-md-0">
            <button class="btn btn-danger  " *ngIf="acssess.bSalariEdit&&saleryData&&saleryData.length!=0"
                (click)="deleteSalery('Mobile_DelCalSalari')">حذف</button>
            <button class="btn btn-warning" *ngIf="acssess.bSalariEdit&&saleryData&&saleryData.length!=0"
                data-bs-toggle="modal" data-bs-target="#edit-all-salery-modal">ویرایش ساعت </button>
        </div>
    </div>
</div>

<div class="col-12 d-flex justify-content-start gap-2 px-2 dirI flex-wrap" *ngIf="type==16">
    <div class="col-md-2 col-5 mt-3">
        <form [formGroup]="dataStart">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </form>
    </div>
    <div class="col-md-2 col-5 mt-3">
        <form [formGroup]="dataEnd">
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">
                <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
            </ng-persian-datepicker>
        </form>
    </div>
    <div class="col-lg-4 col-6 align-items-end d-flex">
        <div class="col-11 mx-auto d-flex gap-2 justify-content-start">
            <button class="btn btn-primary" (click)="searchSalery('Mobile_GetSalariBaseZone')"><i
                    class="fa fa-search fa-lg"></i>&nbsp;</button>
            <button class="btn btn-info" *ngIf="acssess.bSalariBaseZoneEdit"
                (click)="searchSalery('Mobile_ReCalSalariBaseZone')"><i
                    class="fa fa-refresh text-white fa-lg"></i>&nbsp;
                بازپردازش</button>
            <button class="btn btn-danger" *ngIf="acssess.bSalariBaseZoneEdit&&saleryData&&saleryData.length!=0"
                (click)="deleteSalery('Mobile_DelCalSalariBaseZone')"><i class="fa fa-trash fa-lg"></i>&nbsp;
                حذف</button>
            <button class="btn btn-warning" *ngIf="acssess.bSalariBaseZoneEdit &&saleryData&&saleryData.length!=0"
                data-bs-toggle="modal" data-bs-target="#edit-all-salery-modal">ویرایش ساعت شروع و پایان</button>
        </div>
    </div>
</div>

<!-- جدول گزارش پیمایش دوره ای از منو اصلی -->
<ng-container *ngIf="Id==1">
    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky">
        <div>
            <button printTitle="گزارش پیمایش دوره ای" printSectionId="print-table-peymayesh"
                class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint> <i class="fa fa-print"></i>&nbsp;
                چاپ</button>
            <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table1')"><i
                    class="fa fa-file-excel-o"></i>&nbsp; خروجی اکسل</button>

        </div>
        <p class="f18 text-white text-center dirI px-3 my-auto">تمام مسافت طی شده : <strong
                class="blueText">{{getSeparatedValue(Total) | faNum}}</strong>
            کیلومتر
    </div>

    <div class="table-responsive rounded-3  my-2" id="print-table-peymayesh"
        style="max-height: 85vh; overflow-y: auto;">
        <p class="f18 text-white text-center dirI px-3 my-auto" id="print-only-flex">تمام مسافت طی شده : <strong
                class="blueText"> {{getSeparatedValue(Total) | faNum}}</strong>&nbsp;
            کیلومتر
        <table class="table mt-1 table-striped" id="excel-table1">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class="">محدوده تاریخ</th>
                    <th scope="col" class="">(km) مسافت</th>
                    <th scope="col" class=""> شماره پرسنلی </th>
                    <th scope="col" class="">نام متحرک </th>
                    <th scope="col" class=""># </th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{dataTa |faNum}} - {{dataAz |faNum}}</th>
                    <th class="text-dark">{{item.fDistance |faNum}}</th>
                    <th class="text-dark">{{item.strPersonnelID |faNum}}</th>
                    <th class="text-dark">{{item.strFullName}}</th>
                    <th class="text-dark">{{i+1|faNum}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<!-- جدول گزارش مصرف سوخت از منو اصلی -->
<ng-container *ngIf="Id==2">
    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky">
        <div>
            <button printTitle="گزارش مصرف سوخت" printSectionId="print-table-fueldConsumption"
                class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint> <i class="fa fa-print"></i>&nbsp;
                چاپ</button>
            <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table-oil')"><i
                    class="fa fa-file-excel-o"></i>&nbsp; خروجی اکسل</button>

        </div>
        <p class="f18 text-white text-center dirI px-3 my-auto">تمام سوخت مصرفی : <strong
                class="blueText">{{getSeparatedValue(TotalL) | faNum}}</strong>
            لیتر
    </div>
    <div class="table-responsive rounded-3  my-2" id="print-table-fueldConsumption"
        style="max-height: 85vh; overflow-y: auto;">
        <p class="f18 text-white text-center dirI px-3 my-auto" id="print-only-flex">تمام سوخت مصرفی : <strong
                class="blueText">{{getSeparatedValue(TotalL) | faNum}}</strong> &nbsp;
            لیتر
        <table class="table mt-1 table-striped" id="excel-table-oil">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class="">(litre) سوخت مصرفی</th>
                    <th scope="col" class="">L/h</th>
                    <th scope="col" class="">مدت کارکرد</th>
                    <th scope="col" class="">(km) مسافت</th>
                    <th scope="col" class="">نام متحرک </th>
                    <th scope="col" class="">شماره پرسنلی </th>
                    <th scope="col" class="">#</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{item.fGasPer100 |faNum}}</th>
                    <th class="text-dark">{{item.fConsumption |faNum}}</th>
                    <th class="text-dark">{{item.strTotalDurationOperation |faNum}}</th>
                    <th class="text-dark">{{item.fDistance |faNum}}</th>
                    <th class="text-dark">{{item.strFullName |faNum}}</th>
                    <th class="text-dark">{{item.strPersonnelID|faNum}}</th>
                    <th class="text-dark">{{i+1 |faNum}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<!-- جدول گزارش خالص کارکرد روزانه -->
<ng-container *ngIf="Id==3">
    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky">
        <div>
            <button printTitle="گزارش خالص کارکرد روزانه" printSectionId="print-table-pureDailyWork"
                class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint> <i class="fa fa-print"></i>&nbsp;
                چاپ</button>
            <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table-work-daily')"><i
                    class="fa fa-file-excel-o"></i>&nbsp; خروجی اکسل</button>

        </div>
    </div>
    <div class="table-responsive rounded-3  my-2" id="print-table-pureDailyWork"
        style="max-height: 85vh; overflow-y: auto;">
        <table class="table mt-1 table-striped" id="excel-table-work-daily">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class="">زمان توقف</th>
                    <th scope="col" class="">زمان حرکت</th>
                    <th scope="col" class="">زمان کل</th>
                    <th scope="col" class="">شماره پرسنلی </th>
                    <th scope="col" class="">نام متحرک </th>
                    <th scope="col" class=""># </th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{item.strParkTime|faNum}}</th>
                    <th class="text-dark">{{item.strAbsoulatFunction|faNum}}</th>
                    <th class="text-dark">{{item.strFunction|faNum}}</th>
                    <th class="text-dark">{{item.strPersonnelID |faNum}}</th>
                    <th class="text-dark">{{item.strFullName}}</th>
                    <th class="text-dark">{{i+1|faNum}}</th>
                </tr>

            </tbody>
        </table>
    </div>
</ng-container>

<table class="table table-striped mt-1 dirI" *ngIf="type==8" id="excel-table-radyab">
    <thead class="">
        <tr class="text-center">
            <th scope="col" class=""># </th>
            <th class="d-none" scope="col">عرض جغرافیایی</th>
            <th class="d-none" scope="col">طول جغرافیایی</th>

            <th scope="col" class="">تاریخ </th>

            <th scope="col" class="">ساعت </th>

            <th scope="col" class="">کاربری ورودی </th>
            <th scope="col" class="">وضعیت </th>
            <th scope="col" class="">مقدار </th>
            <th scope="col" class="text-white d-none">نام راننده </th>
            <th scope="col" class="text-white d-none">حوزه خدمت </th>
            <th scope="col" class="text-white d-none">گروه </th>
            <th scope="col" class="text-white d-none">پلاک </th>

        </tr>
    </thead>
    <tbody>
        <tr class="text-center" *ngFor="let item of gpdioData;let i=index"
            (click)="setJournal(item.fLat,item.fLon,item.strIOName,item.strTime,item.strDate)">
            <th class="text-secondary">{{i+1}}</th>
            <td class="d-none">{{item.fLat}}</td>
            <td class="d-none">{{item.fLon}}</td>
            <th class="text-secondary">{{item.strDate |faNum}}</th>
            <th class="text-secondary">{{item.strTime|faNum}}</th>
            <th class="text-secondary">{{item.strIOUsage_strComment|faNum}}</th>
            <th class="text-secondary">{{item.strValueTitle|faNum}}</th>
            <th class="text-secondary">{{item.strValue|faNum}}</th>
            <th class="text-secondary d-none">{{item.strFullName}}</th>
            <th class="text-secondary d-none">{{item.strMobileDomain_strComment}}</th>
            <th class="text-secondary d-none">{{item.strMobileType_strComment}}</th>
            <th class="text-secondary d-none">{{item.strVehicleNo|faNum}}</th>
        </tr>

    </tbody>
</table>

<!-- گزارش کارکرد مابین مبدا و مقصد صفحه اصلی -->

<ng-container *ngIf="Id==6">
    <div class="table-responsive dirI rounded-3" style="max-height: 80vh; overflow-y: auto;"
        id="print-table-InOutMainRep">
        <p class="d-flex justify-content-center align-items-center my-2" id="print-only-flex">{{this.dataAz | faNum}} -
            {{this.dataTa | faNum}}</p>
        <div class="w-100 bg-th-blue position-sticky border-top" style="bottom: 0;">
            <div class="d-flex justify-content-around align-items-center flex-wrap mb-2 dirI ">
                <span class="text-white ">تعداد کل سیر : {{summeryForRiderSalary.totalTravel
                    |
                    faNum}}</span>
                <span class="text-white ">جمع کل مدت سیر : "{{summeryForRiderSalary.totalTime | faNum}}
                    <small>
                    </small></span>
                <span class="text-white ">جمع کل پیمایش :
                    {{getSeparatedValue(summeryForRiderSalary.totaldTravel)}}<small>
                        کیلومتر</small></span>
                <div class="d-flex justify-content-center gap-2 align-items-center">
                    <button class="btn btn-success pointer no-print" (click)="exportexcel('excel-table-InOutMainRep') ">
                        اکسل
                        <i class="fa fa-file-excel-o"></i></button>
                    <button printTitle="گزارش کارکرد مابین مبدا و مقصد" printSectionId="print-table-InOutMainRep"
                        class="btn btn-secondary pointer no-print" [useExistingCss]="true" ngxPrint>چاپ <i
                            class="fa fa-print"></i></button>
                </div>
            </div>
        </div>
        <table class="table table-striped mt-1 dirI" id="excel-table-InOutMainRep">
            <thead class="sticky-top bg-white">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="">شماره پرسنلی</th>
                    <th scope="col" class="">راننده</th>
                    <th scope="col" class="">پلاک</th>
                    <th scope="col" class="">حوزه خدمت</th>
                    <th scope="col" class="">نام محدوده شروع</th>
                    <th scope="col" class="">نام محدوده پایان</th>
                    <th scope="col" class="">تعداد سیر</th>
                    <th scope="col" class="">جمع مدت سیر</th>
                    <th scope="col" class="">جمع پیمایش سیر (km)</th>
                    <th scope="col" class="">جمع مدت حضور در محدوده شروع</th>
                    <th scope="col" class="">جمع مدت حضور در محدوده پایان</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f12" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{i+1 | faNum}}</th>
                    <th class="text-success">{{item.strPersonnelID |faNum}}</th>
                    <th class="text-primary">{{item.strFullName }}</th>
                    <th class="text-dark license-plate d-block"
                        style="color: #0400ff; height: auto; margin-top: .1rem;">
                        {{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>
                    <th class="text-dark">{{item.strMobileDomain_strComment}}</th>
                    <th class="text-dark">{{item.strGeoFence_Origin | faNum}}</th>
                    <th class="text-dark">{{item.strGeoFence_Destination | faNum}}</th>
                    <th class="text-dark">{{item.iCount|faNum}}</th>
                    <th class="text-dark">{{item.strTime|faNum}}</th>
                    <th class="text-dark">{{item.fNavigation|faNum}}</th>
                    <th class="text-dark">{{item.strPresenceSTime|faNum}}</th>
                    <th class="text-dark">{{item.strPresenceDTime|faNum}}</th>
                </tr>

            </tbody>
        </table>
    </div>
</ng-container>

<!-- گزارش حقوق رانندگان -->
<ng-container *ngIf="Id==4">
    <div class="w-100 bg-th-blue position-sticky border-top" style="bottom: 0;">
        <div class="d-flex justify-content-around align-items-center flex-wrap mb-2 dirI ">
            <span class="text-white ">جمع ساعت کارکرد : {{summeryForRiderSalary.totalTime
                |
                faNum}}</span>
            <span class="text-white ">جمع پیمایش : {{toPersian(summeryForRiderSalary.totalRide | number:
                '1.0-0')}}
                <small>
                    کیلومتر</small></span>
            <span class="text-white ">جمع حقوق : {{toPersian(summeryForRiderSalary.totalSalary | number:
                '1.0-0')}}<small>
                    ریال</small></span>
            <div class="d-flex justify-content-center gap-2 align-items-center">
                <button class="btn btn-success pointer" (click)="exportexcel('excel-table-saleryDriver') "> اکسل
                    <i class="fa fa-file-excel-o"></i></button>
                <button printTitle="گزارش حقوق رانندگان" printSectionId="print-section1"
                    class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i
                        class="fa fa-print"></i></button>
            </div>
        </div>
    </div>
    <div class="table-responsive dirI rounded-3" style="max-height: 80vh; overflow-y: auto;">
        <table class="table table-striped mt-1 dirI" id="excel-table-saleryDriver">
            <thead class="sticky-top bg-white">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="d-none"> تاریخ شروع </th>
                    <th scope="col" class="d-none">تاریخ پایان </th>
                    <th scope="col" class="">شماره پرسنلی </th>
                    <th scope="col" class="">نام و نام خانوادگی </th>
                    <th scope="col" class="">پلاک </th>
                    <th scope="col" class="">ساعت سرویس </th>
                    <th scope="col" class="">حوزه خدمت </th>
                    <th scope="col" class="">نوع خودرو </th>
                    <th scope="col" class="">ساعت حضور </th>
                    <th scope="col" class="">اضافه کاری </th>
                    <th scope="col" class="">اضافه کاری تشویقی </th>
                    <th scope="col" class=""> پیمایش شهری </th>
                    <th scope="col" class="">پیمایش ماموریتی </th>
                    <th scope="col" class="">پیمایش تشویقی </th>
                    <th scope="col" class="">پیمایش کل </th>
                    <th scope="col" class="">حقوق </th>
                    <th scope="col" class="d-none">Imei </th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f12" *ngFor="let item of riderSalery;let i=index">
                    <th class="text-dark">{{i+1 | faNum}}</th>
                    <th class="text-dark d-none">{{dataAz|faNum}}</th>
                    <th class="text-dark d-none">{{dataTa|faNum}}</th>
                    <th class="text-success">{{item.strPersonnelID |faNum}}</th>
                    <th class="text-primary">{{item.strFullName }}</th>
                    <th class="text-dark license-plate d-block"
                        style="color: #0400ff; height: auto; margin-top: .1rem;">
                        {{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>
                    <th class="text-dark">{{item.strServiceCharge|faNum}}</th>
                    <th class="text-dark">{{item.strMobileDomain_strComment}}</th>
                    <th class="text-dark">{{item.strGPSType_strComment}}</th>
                    <th class="text-dark">{{item.strPresentTime | faNum}}</th>
                    <th class="text-dark">{{item.strOvertime|faNum}}</th>
                    <th class="text-dark">{{item.strEncouragOvertime | faNum}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.fKmInTown)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.fKmMission)}}</th>
                    <th class="text-success">{{getSeparatedValue(item.iIncentiveKm)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.fTotalKm)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iSalary)}}</th>
                    <th class="text-success d-none">{{item.strUnitID |faNum}}</th>
                </tr>

            </tbody>
        </table>
    </div>
</ng-container>

<!-- جدول سررسید سرویس -->
<ng-container *ngIf="Id=='repairServices'">
    <div class="d-flex justify-content-end gap-2 p-2 me-2">
        <button printTitle="گزارش سررسید سرویس ها" printSectionId="print-table-periodicReport"
            class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i class="fa fa-print"></i></button>
        <button class="btn btn-success pointer" (click)="exportexcel( 'excel-table-periodicServices') "> خروجی اکسل
            <i class="fa fa-file-excel-o"></i></button>
    </div>
    <div class="table-responsive dirI rounded-3  my-2" id="print-table-periodicReport"
        style="max-height: 85vh; overflow-y: auto;">
        <table class="table table-striped mt-1 dirI" id="excel-table-periodicServices">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="">پلاک</th>
                    <th scope="col" class="">VIN</th>
                    <th scope="col" class="">نوع خودرو</th>
                    <th scope="col" class="">مدل</th>
                    <th scope="col" class="">حوزه خدمت </th>
                    <th scope="col" class="">نام خودرو</th>
                    <th scope="col" class="">کیلومتر فعلی</th>
                    <th scope="col" class="">موضوع</th>
                    <th scope="col" class="">نوع سررسید</th>
                    <th scope="col" class="">زمان سررسید</th>
                    <th scope="col" class="">کیلومتر سررسید</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f12" *ngFor="let item of repairReport;let i=index">
                    <th class="text-dark">{{i+1 | faNum}}</th>
                    <th class="text-dark d-block"
                        style="font-family: 'bYekan'; color: #0400ff; height: auto; margin-top: .1rem;">
                        {{otherService.returnCorrectPlate(item.strVehicleNo)| faNum}}</th>
                    <th class="text-primary">{{item.strVIN }}</th>
                    <th class="text-primary">{{item.strMobileType_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strGPSType_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strMobileDomain_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strGPSType_strComment | faNum}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.fLastKM)}}</th>
                    <th class="text-dark">{{item.strRepairMaintenanceSubject_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strMaintenanceMaturity_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strvMaintenanceNextMaturity_strDate | faNum}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.ivMaintenanceNextMaturity_iKM)}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<!-- جدول گزارش تعمیرات -->
<ng-container *ngIf="Id==5">
    <div class="w-100 bg-th-blue position-sticky border-top" style="bottom: 0;" *ngIf="repairReport?.length > 0">
        <div class="d-flex justify-content-between align-items-center flex-wrap ps-4 mb-2 dirI ">
            <span *ngIf="summeryForRiderSalary.totalCost" class="text-white ">جمع هزینه ها :
                {{toPersian(summeryForRiderSalary.totalCost | number:
                '1.0-0')}}<small>
                    ریال</small></span>
            <div class="d-flex justify-content-center gap-2 align-items-center">
                <button class="btn btn-success pointer" (click)="exportexcel( 'excel-table-repairReport') "> خروجی اکسل
                    <i class="fa fa-file-excel-o"></i></button>
                <button printTitle="گزارش تعمیرات" printSectionId="print-table-repairReport"
                    class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i
                        class="fa fa-print"></i></button>
            </div>
        </div>
    </div>
    <div class="table-responsive dirI rounded-3  my-2" id="print-table-repairReport"
        style="max-height: 85vh; overflow-y: auto;">
        <table class="table table-striped mt-1 dirI" id="excel-table-repairReport">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="">پلاک</th>
                    <th scope="col" class="">نام راننده</th>
                    <th scope="col" class="">مدل</th>
                    <th scope="col" class="">حوزه خدمت </th>
                    <th scope="col" class="">نوع خودرو</th>
                    <th scope="col" class="">نام خودرو</th>
                    <th scope="col" class="">سرجمع هزینه (ریال)</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f14" *ngFor="let item of repairReport;let i=index">
                    <th class="text-dark">{{i+1 | faNum}}</th>
                    <th class="text-dark d-block"
                        style="font-family: 'bYekan'; color: #0400ff; height: auto; margin-top: .1rem;">
                        {{otherService.returnCorrectPlate(item.strVehicleNo) | faNum }}</th>
                    <th class="text-dark">{{item.strFullName }}</th>
                    <th class="text-dark">{{item.iYearConstruction | faNum}}</th>
                    <th class="text-dark">{{item.strMobileDomain_strComment}}</th>
                    <th class="text-dark">{{item.strMobileType_strComment}}</th>
                    <th class="text-dark">{{item.strGPSType_strComment}}</th>
                    <th class="text-primary">{{getSeparatedValue(item.iTotalCost)}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<!-- جدول بازرسی تاسیسات -->
 
<ng-container *ngIf="type == 18">

    <div class="col-12 px-2 d-flex justify-content-start gap-2 dirI flex-wrap">

        <!-- از تاریخ -->

        <div class="col-md-2 col-11 mt-3">

            <form [formGroup]="mdl_Date">

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="strSDate" class="form-control shadow text-end" readonly />

                </ng-persian-datepicker>

            </form>

        </div>

        <!-- تا تاریخ -->

        <div class="col-md-2 col-11 mt-3">

            <form [formGroup]="mdl_Date">

                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                    <input type="text" formControlName="strEDate" class="form-control shadow text-end" readonly />

                </ng-persian-datepicker>

            </form>

        </div>

        <!-- دکمه ها -->

        <div class="col-md-6 col-12 mt-3 gap-2 d-flex justify-content-start flex-wrap">

            <button class="btn btn-primary" (click)="searchInspections()"> جستجو </button>

            <button class="btn btn-danger" (click)="deleteSalery('Radyab_GeoFence_InspectionReport_Delete')"> حذف تحلیل </button>

            <ng-container *ngIf="reportData?.length > 0">

                <button class="btn btn-warning" (click)="routeForInspection(reportData)"> مسیر حرکت </button>

            </ng-container>

        </div>

    </div>

    <div class="table-responsive dirI rounded-3 my-2" id="print-table-inspection" style="max-height: 85vh; overflow-y: auto;">

        <div *ngIf="reportData?.length > 0" class="w-100 bg-th-blue position-sticky border-top my-2 p-1" style="bottom: 0;">

            <div class="d-flex justify-content-around align-items-center flex-wrap mb-2 dirI">

                <span class="text-white" id="print-only-flex"> تاریخ : {{ mdl_Date.controls["strSDate"].value | faNum }} - {{mdl_Date.controls["strEDate"].value | faNum}} </span>

                <span class="text-white"> تعداد نیم راهی : {{ this.summeryForRiderSalary.totalVisited |faNum }} مورد </span>

                <span class="text-white"> جمع پیمایش : {{ getSeparatedValue(this.summeryForRiderSalary.totalTravel) | faNum }}

                    <small> متر </small>

                </span>

                <span class="text-white "> مدت سیر : {{ this.summeryForRiderSalary.totalTime | faNum}}</span>
                
                <span class="text-white "> تعداد توقف : {{ this.summeryForRiderSalary.totalStop | faNum}}</span>

                <span class="text-white "> مدت توقف : {{ this.summeryForRiderSalary.totalStopTime | faNum}}</span>

                <div class="d-flex justify-content-center gap-2 align-items-center">

                    <button printTitle="گزارش بازرسی تاسیسات" printSectionId="print-table-inspection" class="btn btn-secondary pointer no-print" [useExistingCss]="true" ngxPrint>
                        
                        چاپ

                        <i class="fa fa-print"></i>

                    </button>

                    <button class="btn btn-success pointer no-print" (click)="exportexcel('excel-table-inspection')">

                        خروجی اکسل 
                        
                        <i class="fa fa-file-excel-o"></i>
                    
                    </button>

                </div>

            </div>

        </div>

        <div class="w-100 p-2 d-print-none">

            <input class="form-control w-100" placeholder="جستجو کنید..." (keyup)="filter_Inspections($event.target.value)">

        </div>

        <div class="w-100 h-100 border p-2"  style="overflow-y: auto;">

            <table class="table table-striped mt-1 dirI" id="excel-table-inspection" style="white-space: nowrap;">
    
                <thead class="">
    
                    <tr class="text-center">
    
                        <th scope="col" class="">#</th>
    
                        <th class="col"> انتخاب </th>
    
                        <th class="col"> عملیات </th>
                        
                        <th class="col bg-light"> مبداء </th>
                        
                        <th class="col bg-light"> ورود </th>

                        <th class="col bg-light"> خروج </th>

                        <th class="col bg-light"> حضور </th>
                        
                        <th class="col bg-light-2"> مقصد </th>

                        <th class="col bg-light-2"> ورود به مقصد </th>

                        <th class="col"> مدت سیر </th>

                        <th class="col"> پیمایش </th>
                        
                        <th class="col"> سرعت متوسط </th>

                        <th class="col"> تعداد توقف </th>
    
                        <th scope="col" class=""> مدت توقف </th>
    
                        <th scope="col" class="d-none pointer" (click)="sortBy(3)">
    
                            وضعیت بازرسی
    
                            &nbsp;<i class="fa fa-sort"></i>
    
                        </th>
    
                    </tr>
    
                </thead>
    
                <tbody>
    
                    <tr class="text-center f14" *ngFor="let item of reportData;let i=index">
    
                        <th class="text-dark">{{i+1 | faNum}}</th>
    
                        <th class="text-dark"> <input type="checkbox"> </th>
    
                        <th class="text-dark">
    
                            <i class="fa fa-car fa-lg pointer" aria-hidden="true" title="حرکت مابین محدوده ها" (click)="openRoute_Inspections('1',item)"></i>
    
                            <i class="fa fa-car fa-lg mx-2 text-success pointer" aria-hidden="true" title="حرکت تا بعدی" (click)="openRoute_Inspections('2',item)"></i>
    
                        </th>
    
                        <td class="text-dark bg-light">{{item.strGeoFenceName | faNum}}</td>

                        <td class="text-dark bg-light" dir="ltr">{{item.strFullEnterTime | faNum}}</td>

                        <td class="text-dark bg-light" dir="ltr">{{item.strFullExitTime | faNum}}</td>

                        <td class="text-dark bg-light">{{item.strPresenceTime | faNum}}</td>

                        <td class="text-dark bg-light-2">{{item.strNexFeoFenceName | faNum}}</td>

                        <td class="text-dark bg-light-2" dir="ltr">{{item.strFullEnterNextTime | faNum}}</td>

                        <td class="text-dark">{{item.strTime | faNum}}</td>

                        <td class="text-dark">{{item.fNavigationKM | faNum}}</td>

                        <td class="text-dark">{{item.iAverageKM | faNum}}</td>

                        <td class="text-dark">{{item.iStops | faNum}}</td>

                        <td class="text-dark">{{item.strStopTime | faNum}}</td>
    
                        <td class="d-none text-dark" [ngStyle]="{'background-color': item.tiStatus == 0? '#888': item.tiStatus == 1? 'rgb(255 0 0 / 42%)': item.tiStatus == 2? '#66ff99': ''}">
                            
                            {{item.strStatus}}
                        
                        </td>
    
                    </tr>
    
                </tbody>
    
            </table>

        </div>


    </div>

</ng-container>


<!-- جدول بازرسی تاسیسات منوی اصلی -->
<ng-container *ngIf="Id==18">

    <div class="col-12 d-flex border-top bg-th-blue position-sticky justify-content-between dirI p-2">

        <div class="d-flex col-md-3 col-5">
            <div class="input-group">
                <input class="form-control py-1" type="search" placeholder="جستجو بر اساس محدوده و راننده..."
                    (input)="filterDataTable(inspectionData.value)" #inspectionData>
            </div>
        </div>

        <div class="d-flex justify-content-center gap-2 align-items-center">
            <button printTitle="گزارش بازرسی تاسیسات" printSectionId="print-table-inspection-main"
                class="btn btn-secondary pointer no-print" [useExistingCss]="true" ngxPrint>چاپ <i
                    class="fa fa-print"></i></button>
            <button class="btn btn-success pointer no-print" (click)="exportexcel('excel-table-inspection-main') ">
                خروجی اکسل
                <i class="fa fa-file-excel-o"></i></button>
        </div>

    </div>

    <div class="table-responsive dirI rounded-3  my-2" id="print-table-inspection-main" style="max-height: 85vh; overflow-y: auto;">

        <div class="d-flex justify-content-center align-items-center p-2" id="print-only-flex">

            <p>گزارش بازرسی تاسیسات از تاریخ {{dataAz | faNum}} تا تاریخ {{dataTa | faNum}}</p>
            
        </div>

        <table class="table table-striped mt-1 dirI" id="excel-table-inspection-main">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class="">#</th>
                    <th scope="col" class="pointer" (click)="sortBy(4)"><i class="fa fa-sort-amount-asc"></i>&nbsp;نام
                        محدوده</th>
                    <th scope="col" class="">وضعیت بازرسی</th>
                    <th scope="col" class="pointer" (click)="sortBy(0)"><i
                            class="fa fa-sort-amount-asc"></i>&nbsp;راننده
                    </th>
                    <th scope="col" class="">پلاک</th>
                    <th scope="col" class="">حوزه خدمت</th>
                    <th scope="col" class="pointer" (click)="sortBy(5)"><i class="fa fa-sort-amount-asc"></i>&nbsp;تعداد
                        بازرسی</th>
                    <th scope="col" class="pointer" (click)="sortBy(6)"><i class="fa fa-sort-amount-asc"></i>&nbsp;مدت
                        کل بازرسی</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f14" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{i+1 | faNum}}</th>
                    <th class="text-dark">{{item.strTitle}}</th>
                    <th class="text-dark"
                        [ngStyle]="{'background-color': item.tiStatus == 0? '#888': item.tiStatus == 1? 'rgb(255 0 0 / 42%)': item.tiStatus == 2? '#66ff99': ''}">
                        {{item.strStatus}}</th>
                    <th class="text-dark">{{item.strFullName}}</th>
                    <th class="text-dark">{{otherService.returnCorrectPlate(item.strVehicleNo) | faNum }} </th>
                    <th class="text-dark">{{item.strMobileDomain_strComment | faNum}}</th>
                    <th class="text-dark">{{item.iCount | faNum}}</th>
                    <th class="text-dark">{{item.strPresenceTime | faNum}}</th>
                </tr>
            </tbody>
        </table>

    </div>

</ng-container>

<!-- گزارش سرجمع -->
<ng-container *ngIf="type == '18-0'">

    <div [formGroup]="mdl_Date" class="col-12 d-flex justify-content-start gap-2 dirI flex-wrap">

        <!-- از تاریخ -->

        <div class="col-md-2 col-11 mt-3 me-4">

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="true" [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strSDate" class="form-control" readonly placeholder="از تاریخ" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-md-2 col-11 mt-3">

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="true" [dateGregorianFormat]="'YYYY/MM/DD'" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strEDate" class="form-control" readonly placeholder="تا تاریخ" />

            </ng-persian-datepicker>

        </div>

        <div class="col-md-6 col-12 mt-3 gap-2 d-flex justify-content-start flex-wrap">

            <button class="btn btn-primary" (click)="search_Summarize()">جستجو</button>

            <button class="btn btn-danger" (click)="remove_Summarize()"> حذف </button>

        </div>

    </div>

    <div class="table-responsive dirI rounded-3 my-2" style="max-height: 85vh; overflow-y: auto;">

        <div *ngIf="reportData?.length > 0" class="w-100 bg-th-blue position-sticky border-top my-2 p-1" style="bottom: 0;">

            <div class="d-flex justify-content-around align-items-center flex-wrap mb-2 dirI">

                <span class="text-white"> تعداد : {{ this.summeryForRiderSalary.totalVisited | faNum }} مورد </span>

                <span class="text-white"> جمع پیمایش : {{ getSeparatedValue(this.summeryForRiderSalary.totalTravel) | faNum}}

                    <small> متر </small>

                </span>

                <span class="text-white">

                       جمع مدت سفر :  {{ this.summeryForRiderSalary.totalTime | faNum}}
                    
                </span>

                <div class="d-flex justify-content-center gap-2 align-items-center">

                    <button class="btn btn-success pointer no-print" (click)="exportexcel('excel-table-summarize') ">

                        خروجی اکسل

                        <i class="fa fa-file-excel-o"></i>

                    </button>

                </div>

            </div>

        </div>

        <div class="w-100 p-2">

            <input class="form-control w-100" placeholder="جستجو کنید ... ( مانند : محدوده مبداء - محدوده مقصد )" (keyup)="filter_Summarize($event.target.value)">

        </div>

        <table class="table table-striped mt-1 dirI" id="excel-table-summarize">

            <thead class="">

                <tr class="text-center">

                    <th scope="col" class="">#</th>

                    <th scope="col" class="pointer" (click)="selectAll_Summarize()">انتخاب</th>

                    <!-- <th scope="col" class="">نام خودرو</th> -->

                    <th scope="col" class=""> مبداء </th>

                    <th scope="col" class=""> مقصد </th>

                    <th scope="col" class=""> تعداد </th>

                    <th scope="col" class=""> سرجمع حضور در مبداء </th>

                    <th scope="col" class="">مدت سفر</th>

                    <th scope="col" class="">متوسط زمان سفر</th>

                    <th scope="col" class="">سرجمع پیمایش</th>
                    
                    <th scope="col" class=""> متوسط سرعت  </th>

                </tr>

            </thead>

            <tbody>

                <tr class="text-center f14" *ngFor="let item of reportData;let i=index">

                    <th class="text-dark">{{ i + 1 | faNum}}</th>

                    <th class="text-dark pointer"> 
                        
                        <input type="checkbox" [checked]="isSelected(item.iGeoFence_OriginDestination)" (change)="setCheckBox($event.target.checked,item)"> 
                    
                    </th>

                    <!-- <th> {{ item.strFullName | faNum }} </th> -->

                    <th> {{ item.strGeoFenceName | faNum }} </th>

                    <th> {{ item.strNexFeoFenceName | faNum }} </th>

                    <th> {{ item.iCount | faNum }} </th>

                    <th> {{ item.strPresenceTime | faNum }} </th>

                    <th> {{ item.strSumTime | faNum }} </th>

                    <th> {{ item.strAverageTime | faNum }} </th>

                    <th> {{ item.fNavigation_km | faNum }} </th>

                    <th> {{ item.iAverageSpeed | faNum }} </th>

                </tr>

            </tbody>

        </table>

    </div>

</ng-container>

<!-- جدول گزارش کارکرد مابین مبدا و مقصد *** ( عملکرد ایاب و ذهاب )   -->

<ng-container *ngIf="type == 17 || type == 20">
    <div class="col-12 d-flex justify-content-around dirI flex-wrap">
        <div class="col-md-2 col-5  mt-3">
            <form [formGroup]="dataStart">
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateFormat]="'jYYYY/jMM/jDD'">
                    <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                </ng-persian-datepicker>
            </form>
        </div>
        <div class="col-md-2 col-5  mt-3">
            <form [formGroup]="dataEnd">
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateFormat]="'jYYYY/jMM/jDD'">
                    <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                </ng-persian-datepicker>
            </form>
        </div>

        <div class="col-md-2 col-5 mt-3" *ngIf="type == 17">

            <select class="form-select dirI" (change)="setDropDown($event, 0)"
                [(ngModel)]="summeryForRiderSalary.source">

                <option class="text-secondary" value="-1" selected disabled> انتخاب مبدا </option>

                <option [value]="item.iGeoFence" *ngFor="let item of GeoFenceData">{{item.strTitle}}</option>

            </select>

        </div>

        <div class="col-md-2 col-5 mt-3" *ngIf="type == 17">

            <select class="form-select dirI" (change)="setDropDown($event, 1)"
                [(ngModel)]="summeryForRiderSalary.destination">

                <option class="text-secondary" value="-1" selected disabled> انتخاب مقصد </option>

                <option [value]="item.iGeoFence" *ngFor="let item of GeoFenceData">{{item.strTitle}}</option>

            </select>

        </div>

        <div class="col-md-2 col-12  mt-3 d-flex justify-content-start flex-wrap">

            <div class=" col-12 col-md-6 d-flex gap-2 justify-content-around flex-row">

                <button class="btn btn-primary" (click)="searchTripStartEnd()">جستجو</button>

                <button class="btn btn-danger"
                    *ngIf="type == 20 && !acssess.bTransportation_DailyReport_Delete ? false : true " (click)="deleteSalery(type == 20 ? 'Radyab_Transportation_DailyReport_Delete' : 
                    
                    'Radyab_RespectOriginDestination_Delete')"> حذف </button>

            </div>

        </div>

    </div>

    <div class="table-responsive dirI rounded-3 p-2 my-2" id="print-table-repairReport"
        style="max-height: 85vh; overflow-y: auto;">

        <div class="w-100 bg-th-blue position-sticky " style="bottom: 0;" *ngIf="tripInOutReport?.length > 0">

            <div
                class="d-flex justify-content-start justify-content-md-around p-2 gap-2 gap-md-0 align-items-center flex-wrap dirI">

                <small class="text-white ">جمع کل مدت حضور در محدوده ها : <b
                        class="text-primary bg-warning px-2 rounded">{{this.summeryForRiderSalary.totalPresense |
                        faNum}}</b> </small>

                <small class="text-white ">جمع کل پیمایش مابین محدوده ها : <b
                        class="text-primary bg-warning px-2 rounded">{{getSeparatedValue(this.summeryForRiderSalary.totalTravel)}}
                        متر </b></small>

                <small class="text-white ">جمع کل مدت حرکت مابین محدوده : <b
                        class="text-primary bg-warning px-2 rounded">{{this.summeryForRiderSalary.totalTime | faNum}}
                    </b></small>

                <small *ngIf="type == 20" class="text-white "> جمع کل حقوق : <b
                        class="text-primary bg-warning px-2 rounded">{{this.summeryForRiderSalary.iSalary.toLocaleString()
                        + ' ریال ' | faNum}} </b></small>

                <div class="w-100 d-flex justify-content-end gap-2 align-items-center mt-2">

                    <button printTitle="گزارش کارکرد مابین مبدا و مقصد" printSectionId="print-table-repairReport"
                        class="btn btn-secondary pointer no-print" [useExistingCss]="true" ngxPrint>چاپ <i
                            class="fa fa-print"></i></button>

                    <button class="btn btn-success pointer no-print" (click)="exportexcel('excel-table-repairReport') ">

                        خروجی اکسل

                        <i class="fa fa-file-excel-o"></i>

                    </button>

                </div>

            </div>

        </div>

        <table class="table table-striped dirI" id="excel-table-repairReport">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <th scope="col" class=""> مسیر </th>
                    <th scope="col" class="" *ngIf="type == 20"> حذف </th>

                    <th scope="col" class="">تاریخ </th>

                    <th scope="col" style="background-color: #fed7aa;">نام خودرو </th>

                    <th scope="col" style="background-color: #fed7aa;">پلاک </th>

                    <th scope="col" style="background-color: #fed7aa;">کد پرسنلی </th>

                    <th scope="col" class="bg-green-light">نام محدوده شروع</th>
                    <th scope="col" class="bg-green-light">زمان ورود</th>
                    <th scope="col" class="bg-green-light">زمان خروج </th>
                    <th scope="col" class="bg-green-light">مدت حضور</th>
                    <th scope="col" class="bg-blue-light">نام محدوده پایان</th>
                    <th scope="col" class="bg-blue-light">زمان ورود </th>
                    <th scope="col" class="bg-blue-light">زمان خروج </th>
                    <th scope="col" class="bg-blue-light">مدت حضور</th>
                    <th scope="col" class="bg-yellow">پیمایش (متر)</th>
                    <th scope="col" class="bg-yellow">زمان</th>
                    <th *ngIf="type == 20" scope="col" class="bg-red-light"> حقوق (ریال) </th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f14" *ngFor="let item of tripInOutReport;let i=index">

                    <th class="text-dark">{{i+1 | faNum}}</th>

                    <td class="text-center"> <img title="نمایش روی نقشه" class="pointer" width="25" height="25"
                            src="../../../assets/Img/road-map.png" (click)="openRoute(item)"> </td>

                    <td *ngIf="type == 20" class="text-center pointer"> <i (click)="remove_Transportaion_Cost(item)"
                            title="حذف" class="fa fa-trash fa-lg text-danger" aria-hidden="true"></i> </td>

                    <th class="text-dark">{{item.strDate | faNum}}</th>

                    <th class="text-dark" style="background-color: #fed7aa;">{{item.strGPSType_strComment}}</th>

                    <th class="text-dark" style="background-color: #fed7aa;">
                        {{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>

                    <th class="text-dark" style="background-color: #fed7aa;">{{item.strPersonnelID | faNum}}</th>

                    <th class="text-dark bg-green-light">{{item.strGeoFence_Origin | faNum}}</th>
                    <th class="text-dark bg-green-light">{{item.strEnterSTime | faNum}}</th>
                    <th class="text-dark bg-green-light">{{item.strExitSTime | faNum}}</th>
                    <th class="text-primary bg-green-light">{{item.strPresenceSTime | faNum}}</th>
                    <th class="text-dark bg-blue-light">{{item.strGeoFence_Destination | faNum}}</th>
                    <th class="text-dark bg-blue-light">{{item.strEnterDTime | faNum}}</th>
                    <th class="text-dark bg-blue-light">{{item.strExitDTime | faNum}}</th>
                    <th class="text-primary bg-blue-light">{{item.strPresenceDTime | faNum}}</th>
                    <th class="text-primary bg-yellow">{{getSeparatedValue(item.fNavigation)}}</th>
                    <th class="text-primary bg-yellow">{{item.strTime | faNum}}</th>
                    <th *ngIf="type == 20" class="text-primary bg-red-light">{{item.iSalary.toLocaleString() | faNum}}
                    </th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<!-- گزارش خودروهای واقع در محدوده -->
<ng-container *ngIf="Id=='presenceCheck'">
    <div class="col-12 d-flex border-top position-sticky justify-content-start gap-2 dirI flex-wrap py-2">
        <div class="d-flex col-md-3 col-5">
            <label class="my-2 ms-2" for="geodata">محدوده: </label>
            <select class="form-select dirI" name="geodata" (change)="setDropDown($event, 2)"
                [(ngModel)]="this.summeryForRiderSalary.area" #mahdude>
                <option [value]="item.iGeoFence" *ngFor="let item of GeoFenceData">{{item.strTitle}}</option>
            </select>
        </div>

        <div class="d-flex col-md-3 col-5">
            <div class="input-group" *ngIf="mahdude.value">
                <input class="form-control py-1" type="search" placeholder="جستجو..."
                    (input)="filterDataTable(areaReportInput.value)" #areaReportInput>
            </div>
        </div>

        <div *ngIf="reportData?.length > 0" class="d-flex gap-2 ms-2">
            <button printTitle="گزارش خودروهای واقع در محدوده" printSectionId="print-table-presenceCheck"
                class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i
                    class="fa fa-print"></i></button>
            <button class="btn btn-success pointer" (click)="exportexcel('excel-table-presenceCheck') "> خروجی اکسل
                <i class="fa fa-file-excel-o"></i></button>
        </div>
    </div>
    <div class="table-responsive dirI rounded-3  my-2" id="print-table-presenceCheck"
        style="max-height: 85vh; overflow-y: auto;">
        <div id="print-only-flex" class="d-flex justify-content-center align-items-center my-4 border">
            <p>گزارش خودروهای واقع در محدوده <strong>{{summeryForRiderSalary.text | faNum}}</strong></p>
        </div>
        <table *ngIf="reportData?.length > 0" class="table mt-1 table-striped  dirI" id="excel-table-presenceCheck">
            <thead class="sticky-top bg-white">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <!-- <th scope="col" class="pointer" (click)="sortBy()"><i class="fa fa-sort-amount-asc"></i>&nbsp;شماره پرسنلی</th> -->
                    <th scope="col" class="pointer" (click)="sortBy(0)"><i
                            class="fa fa-sort-amount-asc"></i>&nbsp;راننده</th>
                    <th scope="col" class="">موبایل</th>
                    <th scope="col" class="">پلاک</th>
                    <th scope="col" class="">گروه</th>
                    <th scope="col" class="pointer" (click)="sortBy(1)"><i class="fa fa-sort-amount-asc"></i>&nbsp;نوع
                    </th>
                    <th scope="col" class="pointer" (click)="sortBy(2)"><i class="fa fa-sort-amount-asc"></i>&nbsp;حوزه
                    </th>
                    <th scope="col" class="">تاریخ و ساعت آخرین لاگ</th>
                    <th scope="col" class="">وضعیت</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer hoverItem" *ngFor="let item of reportData;let i=index"
                    (click)="setlocation(item.strFullName, item.fLat,item.fLon,item.strDate,item.strAddress,item.strSTime,item.strETime,item.strParkTime)">
                    <th class="text-dark">{{i+1|faNum}}</th>
                    <th class="text-dark">{{item.strFullName}}</th>
                    <th class="text-dark">{{item.strMobile |faNum}}</th>
                    <th class="text-dark">{{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>
                    <th class="text-dark">{{item.strMobileGroup_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strMobileType_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strMobileDomain_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strDate | faNum}} - {{item.strTime | faNum}}</th>
                    <th class="text-dark">{{item.strDeviceStatus_strComment}}</th>
                </tr>

            </tbody>
        </table>
    </div>
    <div *ngIf="reportData?.length < 1" class="d-flex flex-column justify-content-center align-items-center"
        style="height: 70vh; overflow-y: auto;">
        <img src="../../../assets/Img/nothingToShow.gif" width="350px" alt="">
        <p class="f18">لطفا محدوده مورد نظر را انتخاب کنید</p>
    </div>
</ng-container>

<!-- گزارش خدمات خودروهای امداد رسان -->
<ng-container *ngIf="Id == 'EmadadReport' || type == '19'">
    <div class="table-responsive dirI rounded-3  my-1" id="print-table-EmadadReport"
        style="max-height: 85vh; overflow-y: auto;">
        <div class="w-100 bg-th-blue position-sticky " style="bottom: 0;" *ngIf="reportData?.length > 0">
            <div id="print-only-flex" class="d-flex justify-content-center align-items-center my-4 border">
                <p>گزارش خدمات رسانی امداد خودرو "<strong>{{summeryForRiderSalary.vehicleName | faNum}}</strong>" از
                    تاریخ
                    {{dataAz | faNum}} تا تاریخ {{dataTa | faNum}}</p>
            </div>
            <div class="d-flex justify-content-around align-items-center flex-wrap dirI">
                <span class="text-white ">تعداد کل خدمت رسانی: {{this.reportData.length |
                    faNum}} مورد</span>
                <span class="text-white ">جمع کل زمان پیمایش:
                    "{{this.summeryForRiderSalary.totalTime | faNum}}</span>
                <span class="text-white ">مجموع پیمایش: {{getSeparatedValue(summeryForRiderSalary.totalTravel) | faNum}}
                    متر</span>
                <div class="d-flex justify-content-center gap-2 align-items-center no-print">
                    <button printTitle="گزارش خودروهای امداد رسان" printSectionId="print-table-EmadadReport"
                        class="btn btn-secondary pointer ms-2" [useExistingCss]="true" ngxPrint>چاپ <i
                            class="fa fa-print"></i></button>
                    <button class="btn btn-success pointer ms-2" (click)="exportexcel('excel-table-EmadadReport') ">
                        خروجی اکسل
                        <i class="fa fa-file-excel-o"></i></button>
                </div>
            </div>
        </div>

        <table *ngIf="reportData?.length > 0 && Id != '19'" class="table mt-1 table-striped  dirI"
            id="excel-table-EmadadReport">
            <thead class="sticky-top bg-white">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="">دکمه ترسیم</th>
                    <th scope="col" class="">تاریخ</th>
                    <th scope="col" class="">ساعت شروع</th>
                    <th scope="col" class="">ساعت پایان</th>
                    <th scope="col" class="">مدت حرکت</th>
                    <th scope="col" class="">پیمایش (متر)</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{i+1|faNum}}</th>

                    <th class="text-dark">{{item.strDate |faNum}}</th>
                    <th class="text-dark">{{item.strSTime | faNum}}</th>
                    <th class="text-dark">{{item.strETime | faNum}}</th>
                    <th class="text-dark">{{item.strTime | faNum}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.fKm) | faNum}}</th>
                </tr>

            </tbody>
        </table>
    </div>
    <div *ngIf="reportData?.length < 1" class="d-flex flex-column justify-content-center align-items-center"
        style="height: 70vh; overflow-y: auto;">
        <img src="../../../assets/Img/nothingToShow.gif" width="350px" alt="">
        <p class="f18">موردی یافت نشد</p>
    </div>
</ng-container>

<!-- گزارش خدمات رسانی خودروها -->
<ng-container *ngIf="Id == '19'">
    <div class="table-responsive dirI rounded-3  my-1" id="print-table-EmadadReport"
        style="max-height: 85vh; overflow-y: auto;">
        <div class="w-100 bg-th-blue position-sticky " style="bottom: 0;" *ngIf="reportData?.length > 0">
            <div class="d-flex justify-content-around align-items-center flex-wrap dirI">
                <span class="text-white ">تعداد کل خدمت رسانی: {{summeryForRiderSalary.totalServices |
                    faNum}} مورد</span>
                <span class="text-white ">جمع کل زمان پیمایش:
                    "{{summeryForRiderSalary.ftotalTime | faNum}}</span>
                <span class="text-white ">مجموع پیمایش: {{getSeparatedValue(summeryForRiderSalary.totalTravel) | faNum}}
                    متر</span>
                <div class="d-flex justify-content-center gap-2 align-items-center no-print">
                    <button printTitle="گزارش خدمات رسانی خودروها" printSectionId="print-table-EmadadReport"
                        class="btn btn-secondary pointer ms-2 no-print" [useExistingCss]="true" ngxPrint>چاپ <i
                            class="fa fa-print"></i></button>
                    <button class="btn btn-success pointer ms-2 no-print"
                        (click)="exportexcel('excel-table-EmadadReport') ">
                        خروجی اکسل
                        <i class="fa fa-file-excel-o"></i></button>
                </div>
            </div>
        </div>
        <table *ngIf="reportData?.length > 0" class="table mt-1 table-striped  dirI" id="excel-table-EmadadReport">
            <thead class="sticky-top bg-white">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="">نام</th>
                    <th scope="col" class="">پلاک</th>
                    <th scope="col" class="">تعداد</th>
                    <th scope="col" class="">مدت</th>
                    <th scope="col" class="">پیمایش (متر)</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{i+1|faNum}}</th>
                    <th class="text-dark">{{item.strfullName | faNum}}</th>
                    <th class="text-dark">{{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>
                    <th class="text-dark">{{item.iCount | faNum}}</th>
                    <th class="text-dark">{{item.strTime | faNum}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.fKm) | faNum}}</th>
                </tr>

            </tbody>
        </table>
    </div>
    <div *ngIf="reportData?.length < 1" class="d-flex flex-column justify-content-center align-items-center"
        style="height: 70vh; overflow-y: auto;">
        <img src="../../../assets/Img/nothingToShow.gif" width="350px" alt="">
        <p class="f18">موردی یافت نشد</p>
    </div>
</ng-container>

<!-- گزارش آخرین حضور در محدوده -->
<ng-container *ngIf="Id=='historyCheck'">
    <div class="col-12 d-flex border-top position-sticky justify-content-start gap-2 dirI flex-wrap py-2">
        <div class="d-flex col-md-3 col-5">
            <label class="my-2 ms-2" for="geodata">محدوده: </label>
            <select class="form-select dirI" name="geodata" (change)="setDropDown($event, 3)"
                [(ngModel)]="this.summeryForRiderSalary.area" #mahdudearea>
                <option [value]="item.iGeoFence" *ngFor="let item of GeoFenceData">{{item.strTitle}}</option>
            </select>
        </div>

        <div class="d-flex col-md-3 col-5">
            <div class="input-group" *ngIf="mahdudearea.value">
                <input class="form-control py-1" type="search" placeholder="جستجو..."
                    (input)="filterDataTable(areaReportInput.value)" #areaReportInput>
            </div>
        </div>

        <div *ngIf="reportData?.length > 0" class="d-flex gap-2 ms-2">
            <button printTitle="گزارش خودروهای واقع در محدوده" printSectionId="print-table-historyCheck"
                class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i
                    class="fa fa-print"></i></button>
            <button class="btn btn-success pointer" (click)="exportexcel('excel-table-historyCheck') "> خروجی اکسل
                <i class="fa fa-file-excel-o"></i></button>
        </div>
    </div>
    <div class="table-responsive dirI rounded-3  my-2" id="print-table-historyCheck"
        style="max-height: 85vh; overflow-y: auto;">
        <div id="print-only-flex" class="d-flex justify-content-center align-items-center my-4 border">
            <p>گزارش آخرین حضور در محدوده <strong>{{summeryForRiderSalary.text | faNum}}</strong></p>
        </div>
        <table *ngIf="reportData?.length > 0" class="table mt-1 table-striped  dirI" id="excel-table-historyCheck">
            <thead class="sticky-top bg-white">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <!-- <th scope="col" class="pointer" (click)="sortBy()"><i class="fa fa-sort-amount-asc"></i>&nbsp;شماره پرسنلی</th> -->
                    <th scope="col" class="pointer" (click)="sortBy(0)"><i
                            class="fa fa-sort-amount-asc"></i>&nbsp;راننده</th>
                    <th scope="col" class="">موبایل</th>
                    <th scope="col" class="">پلاک</th>
                    <th scope="col" class="">گروه</th>
                    <th scope="col" class="pointer" (click)="sortBy(1)"><i class="fa fa-sort-amount-asc"></i>&nbsp;نوع
                    </th>
                    <th scope="col" class="pointer" (click)="sortBy(2)"><i class="fa fa-sort-amount-asc"></i>&nbsp;حوزه
                    </th>
                    <th scope="col" class="">تاریخ و ساعت آخرین حضور</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer hoverItem" *ngFor="let item of reportData;let i=index"
                    (click)="setlocation(item.strFullName, item.dLatitude,item.dLongitude,item.strDate, '','','','')">
                    <th class="text-dark">{{i+1|faNum}}</th>
                    <th class="text-dark">{{item.strFullName}}</th>
                    <th class="text-dark">{{item.strMobile |faNum}}</th>
                    <th class="text-dark">{{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>
                    <th class="text-dark">{{item.strMobileGroup_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strMobileType_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strMobileDomain_strComment | faNum}}</th>
                    <th class="text-dark">{{item.strDate | faNum}} - {{item.strTime | faNum}}</th>
                </tr>

            </tbody>
        </table>
    </div>
    <div *ngIf="reportData?.length < 1" class="d-flex flex-column justify-content-center align-items-center"
        style="height: 70vh; overflow-y: auto;">
        <img src="../../../assets/Img/nothingToShow.gif" width="350px" alt="">
        <p class="f18">لطفا محدوده مورد نظر را انتخاب کنید</p>
    </div>
</ng-container>

<!-- گزارش حضور اتوبوس در ایستگاه ها -->
<ng-container *ngIf="Id=='busPresence'">
    <div class="d-flex col-12 border-top position-sticky justify-content-aroubd gap-2 dirI flex-wrap py-2">
        <div class="d-flex col-md-3 col-5">
            <label class="my-2 ms-2" for="busList">اتوبوس: </label>
            <select class="form-select dirI" name="busList" [(ngModel)]="summeryForRiderSalary.bus">
                <option [value]="item.strUnitID" *ngFor="let item of buses">{{item.strFullName}}</option>
            </select>
        </div>


        <div class="col-md-3 col-11 ms-4">
            <form [formGroup]="dataStart">
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateFormat]="'jYYYY/jMM/jDD'">
                    <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                </ng-persian-datepicker>
            </form>
        </div>

        <button class="btn btn-primary " (click)="getBusesInLines()">جستجو</button>

        <div *ngIf="reportData?.length > 0" class="d-flex gap-2" style="margin: auto">
            <button printTitle="گزارش حضور اتوبوس در ایستگاه ها" printSectionId="print-table-busPresence"
                class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i
                    class="fa fa-print"></i></button>
            <button class="btn btn-success pointer" (click)="exportexcel('excel-table-busPresence') "> خروجی اکسل
                <i class="fa fa-file-excel-o"></i></button>
        </div>
    </div>
    <div class="table-responsive dirI rounded-3  my-2" id="print-table-busPresence"
        style="max-height: 85vh; overflow-y: auto;">
        <table class="table table-striped mt-1 dirI" id="excel-table-busPresence">
            <thead class="">
                <tr class="text-center fw-bold">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="">نام خط </th>
                    <th scope="col" class="">کد خط </th>
                    <th scope="col" class="">نام ایستگاه</th>
                    <th scope="col" class="">کد ایستگاه</th>
                    <th scope="col" class="">ساعت حضور در ایستگاه </th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f13" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{i+1 | faNum}}</th>
                    <th class="text-dark">{{item.strBusLineName | faNum}}</th>
                    <th class="text-dark">{{item.strBusLineCode | faNum}}</th>
                    <th class="text-dark">{{item.strBusStopName|faNum}}</th>
                    <th class="text-dark">{{item.strBusStopCode | faNum}}</th>
                    <th class="text-dark">{{item.strTime | faNum}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<!-- گزارش حضور اتوبوس ها در ایستگاه -->
<ng-container *ngIf="Id=='station'">
    <div class="col-12 d-flex border-top position-sticky justify-content-start gap-2 dirI flex-wrap py-2">
        <div class="d-flex col-md-3 col-5 ms-2">
            <select class="form-select dirI" name="line" (change)="setDropDown($event, 4)">
                <option value="-1" selected>انتخاب خط مورد نظر...</option>
                <option [value]="item.iBusLine" *ngFor="let item of buses">{{item.strBusLineName}}</option>
            </select>
        </div>
        <div *ngIf="filteredData?.length > 0" class="d-flex col-md-3 col-5 ms-2">
            <select class="form-select dirI" name="line" [(ngModel)]="summeryForRiderSalary.station">
                <option value="-1" selected>انتخاب ایستگاه مورد نظر...</option>
                <option [value]="item.iBusStop" *ngFor="let item of filteredData">{{item.strBusStopName}}</option>
            </select>
        </div>
        <div *ngIf="filteredData?.length > 0" class="d-flex col-md-2 col-11">
            <span class="py-2">از:&nbsp;</span>
            <form [formGroup]="dataStart">
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateFormat]="'jYYYY/jMM/jDD'">
                    <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                </ng-persian-datepicker>
            </form>
        </div>
        <div *ngIf="filteredData?.length > 0" class="d-flex col-md-2 col-11">
            <span class="py-2">تا:&nbsp;</span>
            <form [formGroup]="dataEnd">
                <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                    [dateFormat]="'jYYYY/jMM/jDD'">
                    <input type="text" formControlName="date" class="form-control shadow text-end" readonly />
                </ng-persian-datepicker>
            </form>
        </div>
        <button *ngIf="summeryForRiderSalary.station" class="btn btn-primary"
            (click)="searchBusesInStation()">جستجو</button>

    </div>
    <div *ngIf="reportData?.length > 0" class="d-flex bg-th-blue gap-2">
        <button printTitle="گزارش حضور اتوبوس ها در ایستگاه" printSectionId="print-table-station"
            class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i class="fa fa-print"></i></button>
        <button class="btn btn-success pointer" (click)="exportexcel('excel-table-station') "> خروجی اکسل
            <i class="fa fa-file-excel-o"></i></button>
    </div>
    <div class="table-responsive dirI rounded-3  my-2" id="print-table-station"
        style="max-height: 85vh; overflow-y: auto;">
        <table *ngIf="reportData?.length > 0" class="table table-striped mt-1 dirI" id="excel-table-station">
            <thead class="">
                <tr class="text-center fw-bold">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="">نام اتوبوس </th>
                    <th scope="col" class="">پلاک اتوبوس</th>
                    <th scope="col" class="">نام خط</th>
                    <th scope="col" class="">ساعت حضور در ایستگاه</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f13" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark">{{i+1 | faNum}}</th>
                    <th class="text-dark">{{item.strFullName | faNum}}</th>
                    <th class="text-dark">{{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>
                    <th class="text-dark">{{item.strBusLineName|faNum}}</th>
                    <th class="text-dark">{{item.strTime | faNum}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<div class="table-responsive dirI rounded-3  my-2" style="max-height: 70vh; overflow-y: auto;"
    *ngIf="type!=15 && type!='15-1' && type!='15-2' && type!=13 && type!=1 && type!=4 && type!=5">

    <ng-container *ngIf="type==14">
        <div class="w-100 bg-th-blue position-sticky " style="bottom: 0; " *ngIf="saleryData?.length > 0">
            <div class="d-flex justify-content-around align-items-center flex-wrap mb-2 dirI ">
                <span class="text-white ">زمان حضور : {{hTotalTime |
                    faNum}}:{{mTotalTime | faNum}}</span>
                <span class="text-white ">زمان توقف : {{hStopTime |
                    faNum}}:{{mStopTime | faNum}}</span>
                <span class="text-white ">زمان حرکت : {{hmoveTime |
                    faNum}}:{{mmoveTime | faNum}}</span>
                <span class="text-white ">میزان پیمایش : {{dictance | faNum}}
                    <small>
                        کیلومتر</small></span>
                <span class="text-white ">اضافه کاری : {{hOvertime | faNum}}:{{mOvertime | faNum}}</span>
                <span class="text-white ">زمان حق سرویس : {{tServiceCharge | faNum}}
                    <small> ساعت</small></span>
                <span class="text-white ">میزان حقوق : {{getSeparatedValue(saleryTotal)}}<small>
                        ریال</small></span>
                <div class="d-flex justify-content-center gap-2 align-items-center">
                    <button class="btn btn-success pointer" (click)="exportexcel( 'excel-table-saleryData') "> اکسل
                        <i class="fa fa-file-excel-o"></i></button>
                    <button printTitle="گزارش حقوق بر اساس ورود و خروج" printSectionId="print-section"
                        class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i
                            class="fa fa-print"></i></button>
                </div>
            </div>
        </div>
        <table class="table table-striped mt-1 dirI" id="excel-table-saleryData">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class=""># </th>
                    <th scope="col" class="" *ngIf="acssess.bSalariEdit"></th>
                    <th scope="col" class="">تاریخ </th>
                    <th scope="col" class="">روز </th>
                    <th scope="col" class=""> شروع </th>
                    <th scope="col" class=""> پایان </th>
                    <th scope="col" class=""> حضور </th>
                    <th scope="col" class=""> توقف </th>
                    <th scope="col" class=""> حرکت </th>
                    <th scope="col" class=""> شهری(km) </th>
                    <th scope="col" class=""> ماموریتی(km) </th>
                    <th scope="col" class=""> کل(km) </th>
                    <th scope="col" class=""> ساعت سرویس </th>
                    <th scope="col" class=""> ساعتی(ريال)</th>
                    <th scope="col" class=""> اضافه‌کاری(ريال)</th>
                    <th scope="col" class=""> شهری(ريال)</th>
                    <th scope="col" class=""> ماموریتی(ريال)</th>
                    <th scope="col" class="">اضافه کار تشویقی </th>
                    <th scope="col" class=""> پیمایش تشویقی(km)</th>
                    <th scope="col" class="">اضافه کاری</th>
                    <th scope="col" class="">حقوق(ريال)</th>
                    <th scope="col" class="">نام محدوده </th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center" *ngFor="let item of saleryData;let i=index">
                    <th class="text-dark">{{i+1 | faNum}}</th>
                    <th class="text-dark" *ngIf="acssess.bSalariEdit"><i class="fa fa-edit pointer text-warning"
                            data-bs-toggle="modal" data-bs-target="#SaleryModal"
                            (click)="editSalery(item.iAttendanceDriver,i)"></i></th>
                    <th class="text-dark">{{item.strDate|faNum}}</th>
                    <th class="text-dark">{{item.strDayName}}</th>
                    <th class="text-success">{{item.strStartTime |faNum}}</th>
                    <th class="text-primary">{{item.strEndTime |faNum}}</th>
                    <th class="text-dark">{{item.strPresentTime|faNum}}</th>
                    <th class="text-dark">{{item.strStopTime |faNum}}</th>
                    <th class="text-dark">{{item.strMoveTime|faNum}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.fKmInTown)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.fKmMission)}}</th>
                    <th class="text-success">{{getSeparatedValue(item.fKmTotal)}}</th>
                    <th class="text-success">{{getSeparatedValue(item.siServiceCharge)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iHourlyRate)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iOvertimeRate)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iUrbanOperationRates)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iNonurbanOperatingRates)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iEncouragOvertime)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iIncentiveKm)}}</th>
                    <th class="text-dark">{{item.strOvertime | faNum}}</th>
                    <th class="text-danger">{{getSeparatedValue(item.iSalary)}}</th>
                    <th class="text-dark">{{item.strTitle }}</th>

                    <!-- <th class="text-secondary">{{item.iNonurbanOperatingRates | number:'1.0':'en-US'}}</th>
                <th class="text-secondary">{{item.iNonurbanOperatingRates | number:'1.0':'en-US'}}</th> -->
                </tr>

            </tbody>
        </table>
        <div id="print-section">
            <div class="row dirI">
                <div class="col-10 text-center align-items-center border">
                    <p class="mt-2 fw-bold">
                        {{loggedinUserName}}
                    </p>
                    <p>گزارش حقوق {{saleryData?.[0].strFullName}}
                        با کد پرسنلی {{saleryData?.[0].strPersonnelID | faNum}} در حوزه خدمت
                        {{saleryData?.[0].strMobileDomain_strComment}} از
                        تاریخ
                        {{dataStart.controls["date"].value | faNum}} تا تاریخ {{dataEnd.controls["date"].value |
                        faNum}}
                    </p>
                </div>
                <div class="col-2 text-center align-items-center border">
                    <p class="p-2">تاریخ تهیه</p>
                    {{currentDate | faNum}}
                </div>
            </div>
            <div class="table-responsive table-striped dirI">
                <table class="table table-bordered">
                    <thead>
                        <tr class="text-center f12">
                            <th scope="col" class="">ردیف </th>
                            <th scope="col" class="">تاریخ </th>
                            <th scope="col" class="">روز </th>
                            <th scope="col" class="">شروع</th>
                            <th scope="col" class="">پایان</th>
                            <th scope="col" class="">حضور</th>
                            <th scope="col" class="">اضافه کاری</th>
                            <th scope="col" class="">تشویقی (ساعت)</th>
                            <th scope="col" class="">سرویس</th>
                            <th scope="col" class="">جمع ساعت</th>
                            <th scope="col" class="">شهری</th>
                            <th scope="col" class="">ماموریتی</th>
                            <th scope="col" class="">تشویقی (km)</th>
                            <th scope="col" class="">جمع پیمایش</th>
                            <th scope="col" class="">حقوق (ریال)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="text-center pointer f10" *ngFor="let item of saleryData; let i = index">
                            <th class="text-secondary">{{i+1 | faNum}}</th>
                            <th class="text-secondary">{{item.strDate|faNum}}</th>
                            <th class="text-secondary">{{item.strDayName}}</th>
                            <th class="text-secondary">{{item.strStartTime|faNum}}</th>
                            <th class="text-secondary">{{item.strEndTime|faNum}}</th>
                            <th class="text-secondary">{{item.strPresentTime|faNum}}</th>
                            <th class="text-secondary">{{item.strOvertime | faNum}}</th>
                            <th class="text-secondary">{{getSeparatedValue(item.iEncouragOvertime)}}</th>
                            <th class="text-secondary">{{getSeparatedValue(item.siServiceCharge)}}</th>
                            <th class="text-secondary">{{item.strTotalTime|faNum}}</th>
                            <th class="text-secondary">{{getSeparatedValue(item.fKmInTown)}}</th>
                            <th class="text-secondary">{{getSeparatedValue(item.fKmMission)}}</th>
                            <th class="text-secondary">{{getSeparatedValue(item.iIncentiveKm)}}</th>
                            <th class="text-secondary">{{item.fTotalKm|faNum}}</th>
                            <th class="text-secondary">{{getSeparatedValue(item.iSalary)}}</th>
                        </tr>
                        <tr class="bg-gray text-center pointer f10"
                            style="print-color-adjust:exact ;-webkit-print-color-adjust:exact">
                            <th class="text-center f12 fw-bold text-dark">جمع:</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th class="text-dark">{{hOvertime | faNum}}:{{mOvertime | faNum}}</th>
                            <th class="text-dark">{{this.summeryForRiderSalary.EncouragOvertime | faNum}}</th>
                            <th class="text-dark">{{this.summeryForRiderSalary.serviceHours | faNum}}</th>
                            <th class="text-dark">{{totalTimeSpent | faNum}}</th>
                            <th class="text-dark">{{summeryForRiderSalary.cityRide}}</th>
                            <th class="text-dark">{{getSeparatedValue(summeryForRiderSalary.OperationRide | number:
                                '1.2-2')}}</th>
                            <th class="text-dark">{{getSeparatedValue(summeryForRiderSalary.encourageRide | number:
                                '1.2-2')}}</th>
                            <th class="text-dark">{{getSeparatedValue(dictance)}}</th>
                            <th class="text-dark">{{getSeparatedValue(saleryTotal)}}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!-- <div class="d-flex flex-wrap gap-4 justify-content-around mt-3 border">
                <span>حقوق کل: {{getSeparatedValue(saleryTotal)}} <small>ریال </small></span>
                <span>اضافه کاری : {{hOvertime | faNum}}:{{mOvertime | faNum}}</span>
                <span>پیمایش شهری : {{getSeparatedValue(summeryForRiderSalary.cityRide | number: '1.2-2')}}
                    کیلومتر</span>
                <span>پیمایش ماموریتی : {{getSeparatedValue(summeryForRiderSalary.OperationRide | number: '1.2-2')}}
                    کیلومتر</span>
                <span>پیمایش تشویقی: {{getSeparatedValue(summeryForRiderSalary.encourageRide | number: '1.2-2')}}
                    کیلومتر</span>
                <span>تشویقی : {{this.summeryForRiderSalary.EncouragOvertime | faNum}} ساعت</span>
                <span>سرویس : {{this.summeryForRiderSalary.serviceHours | faNum}} ساعت</span>
                <span>پیمایش کل : {{getSeparatedValue(dictance)}} <small>کیلومتر </small></span>
                <span>زمان کل : {{totalTimeSpent | faNum}} <small>دقیقه </small></span>
            </div> -->
        </div>
    </ng-container>


    <!-- گزارش حقوق بر اساس فعالیت در منطقه -->
    <ng-container *ngIf="type==16">
        <div class="table-responsive dirI rounded-3 my-2" style="max-height: 70vh; overflow-y: auto;"
            id="print-table-areaTravel">
            <div class="w-100 bg-th-blue position-sticky" style="bottom: 0; " *ngIf="saleryData?.length > 0">
                <div class="d-flex justify-content-around align-items-center flex-wrap dirI">
                    <span class="text-white">زمان کل : {{sTotalTime | faNum}} :{{mTotalTime | faNum}} :{{hTotalTime |
                        faNum}}</span>
                    <span class="text-white">زمان توقف : {{sStopTime | faNum}} :{{mStopTime | faNum}} :{{hStopTime |
                        faNum}}</span>
                    <span class="text-white">زمان حرکت : {{smoveTime | faNum}} :{{mmoveTime | faNum}} :{{hmoveTime |
                        faNum}}</span>
                    <span class="text-white">میزان پیمایش : {{dictance | faNum}} کیلومتر</span>
                    <span class="text-white">میزان حقوق : {{getSeparatedValue(saleryTotal) | faNum}}
                        ریال</span>
                    <div class="d-flex justify-content-center gap-2 align-items-center no-print">
                        <button class="btn btn-success pointer no-print"
                            (click)="exportexcel('excel-table-areaTravel') "> اکسل
                            <i class="fa fa-file-excel-o"></i></button>
                        <button printTitle="گزارش حقوق بر اساس ورود و خروج" printSectionId="print-table-areaTravel"
                            class="btn btn-secondary pointer no-print" [useExistingCss]="true" ngxPrint>چاپ <i
                                class="fa fa-print"></i></button>
                    </div>
                </div>
            </div>
            <table class="table table-striped mt-1 dirI" id="excel-table-areaTravel">

                <thead class="">

                    <tr class="text-center">

                        <th scope="col" class=""># </th>

                        <th scope="col" class="" *ngIf="acssess.bSalariBaseZoneEdit">ویرایش </th>

                        <th scope="col" class="">تاریخ </th>

                        <th scope="col" class="">روز </th>

                        <th scope="col" class="">نام خودرو </th>

                        <th scope="col" class="">پلاک </th>

                        <th scope="col" class="">پرسنلی </th>

                        <th scope="col" class="">ساعت شروع </th>

                        <th scope="col" class="">ساعت پایان </th>

                        <th scope="col" class="">مدت حضور </th>

                        <th scope="col" class="">مدت توقف </th>

                        <th scope="col" class="">مدت حرکت </th>

                        <th scope="col" class="">پیمایش کل </th>

                        <th scope="col" class="">حقوق </th>

                        <th scope="col" class="">نرخ ساعتی </th>

                        <th scope="col" class="">نرخ پیمایش</th>

                        <th scope="col" class="">نام محدوده فعالیت </th>

                    </tr>

                </thead>

                <tbody>
                    <tr class="text-center" *ngFor="let item of saleryData;let i=index">

                        <th class="text-dark">{{ i + 1 | faNum }}</th>

                        <th class="text-dark" *ngIf="acssess.bSalariBaseZoneEdit">

                            <i class="fa fa-edit pointer text-warning" data-bs-toggle="modal"
                                data-bs-target="#SaleryModal" (click)="editSalery(item.iAttendanceDriver,i)"></i>

                        </th>

                        <th class="text-dark">{{item.strDate|faNum}}</th>

                        <th class="text-dark">{{item.strDayName}}</th>

                        <th class="text-dark">{{item.strFullName}}</th>

                        <th class="text-dark">{{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>

                        <th class="text-dark">{{item.strPersonnelID | faNum}}</th>

                        <th class="text-success">{{item.strStartTime |faNum}}</th>
                        <th class="text-primary">{{item.strEndTime |faNum}}</th>
                        <th class="text-dark">{{item.strPresentTime|faNum}}</th>
                        <th class="text-dark">{{item.strStopTime |faNum}}</th>
                        <th class="text-dark">{{item.strMoveTime|faNum}}</th>
                        <th class="text-success">{{getSeparatedValue(item.fKmTotal) }}</th>
                        <th class="text-danger">{{getSeparatedValue(item.iSalary) }}</th>
                        <th class="text-dark">{{getSeparatedValue(item.iHourlyRate)}}</th>
                        <th class="text-dark">{{getSeparatedValue(item.iUrbanOperationRates)}}</th>
                        <th class="text-dark">{{item.strTitle}}</th>
                        <!-- <th class="text-secondary">{{item.iNonurbanOperatingRates | number:'1.0':'en-US'}}</th>
                <th class="text-secondary">{{item.iNonurbanOperatingRates | number:'1.0':'en-US'}}</th> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </ng-container>
</div>

<!-- گزارش توقفات -->

<ng-container *ngIf="type == 1 || type == '1-3' || type == '1-4' ">

    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky">

        <div class="p-2">

            <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table-stop')">

                <i class="fa fa-file-excel-o"></i> &nbsp; خروجی اکسل

            </button>

            <button *ngIf="type == 1" class="btn btn-secondary" [routerLink]="[ '/stopMap/', Id + '$'] ">

                <i class="fa fa-map-marker fa-lg"></i>&nbsp; جانمایی توقف ها بر روی نقشه </button>

            <button *ngIf="type == '1-3'" class="btn btn-secondary" [routerLink]="[ '/stopMap/', Id + '|'] ">

                <i class="fa fa-map-marker fa-lg"></i>&nbsp; جانمایی توقف ها بر روی نقشه </button>

            <button *ngIf="type == '1-4'" class="btn btn-secondary" [routerLink]="[ '/stopMap/', Id + '='] ">

                <i class="fa fa-map-marker fa-lg"></i>&nbsp; جانمایی توقف ها بر روی نقشه </button>
        </div>

        <div class="p-2" *ngIf="type != 1">

            <span> تعداد : <b> {{ reportData.length | faNum }} </b> </span>

            <span class="mx-3"> سرجمع مقدار : <b> {{ total_fValue | number:'1.2-2' | faNum }} </b> لیتر </span>

        </div>

    </div>

    <table class="table mt-1 table-striped" id="excel-table-stop">

        <thead class="">

            <ng-container *ngIf="type == 1">

                <tr class="dirI">

                    <th scope="col" class="" [ngClass]="isDesktop  ? '' : 'd-none'">آدرس</th>

                    <th scope="col" class="">زمان توقف</th>

                    <th scope="col" class="">زمان پایان</th>

                    <th scope="col" class="">زمان شروع </th>

                    <th scope="col" class=""> تاریخ </th>

                    <th scope="col" class=""> نام خودرو </th>

                    <th scope="col" class=""> # </th>

                </tr>

            </ng-container>

            <ng-container *ngIf="type == '1-3' || type == '1-4'">

                <tr class="dirI">

                    <th scope="col" class=""> آدرس </th>

                    <th scope="col" class=""> مقدار </th>

                    <th scope="col" class=""> تاریخ </th>

                    <th scope="col" class=""> نام خودرو </th>

                    <th scope="col" class=""> # </th>

                </tr>

            </ng-container>

        </thead>

        <tbody>

            <ng-container *ngIf="type == 1">

                <tr class="dirI pointer hoverItem" *ngFor="let item of reportData;let i=index"
                    (click)="setlocation('',item.fLat,item.fLon,item.strDate,item.strAddress,item.strSTime,item.strETime,item.strParkTime)">

                    <th class="text-dark" [ngClass]="isDesktop  ? '' : 'd-none'">{{item.strAddress}}</th>

                    <th class="text-dark">{{item.strParkTime | faNum }}</th>

                    <th class="text-dark">{{item.strETime| faNum }}</th>

                    <th class="text-dark">{{item.strSTime| faNum }}</th>

                    <th class="text-dark">{{item.strDate | faNum }}</th>

                    <th class="text-dark">{{item.strFullName | faNum }}</th>

                    <th class="text-dark">{{ i + 1 | faNum }}</th>

                </tr>

            </ng-container>

            <ng-container *ngIf="type == '1-3' || type == '1-4'">

                <tr class="dirI pointer hoverItem" *ngFor="let item of reportData;let i=index">

                    <th class="text-dark">{{item.strAddress | faNum }}</th>

                    <th class="text-dark">{{item.fValue | faNum }}</th>

                    <th class="text-dark">{{item.strDateTime | faNum }}</th>

                    <th class="text-dark">{{item.strFullName | faNum }}</th>

                    <th class="text-dark">{{ i + 1 | faNum }}</th>

                </tr>



            </ng-container>

        </tbody>

    </table>

</ng-container>

<!-- گزارش تعداد مرتبه آبگیری تانکر در طی بازه زمانی به تفکیک دوش -->

<ng-container *ngIf="type== '1-1'">

    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky p-2">

        <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table-stop')"><i
                class="fa fa-file-excel-o"></i>&nbsp; خروجی اکسل</button>

        <!-- <button class="btn btn-secondary" [routerLink]="[ '/stopMap/',Id+ '&_'] "><i class="fa fa-map-marker fa-lg"></i>&nbsp; نمایش همه بر روی نقشه </button> -->

    </div>

    <table class="table mt-1 table-striped" id="excel-table-stop">

        <thead class="">

            <tr class="dirI text-center">

                <th scope="col" class="">تعداد تغذیه </th>

                <th scope="col" class="">حجم کل تغذیه </th>

                <th scope="col" class=""> محل تامین </th>

                <th scope="col" class=""># </th>

            </tr>

        </thead>

        <tbody>

            <tr class="dirI text-center " *ngFor="let item of reportData;let i=index">

                <th class="text-dark">{{item.iCount|faNum}}</th>

                <th class="text-dark">{{item.fFeedingValue.toLocaleString() + ' لیتر ' |faNum}}</th>

                <th class="text-dark">{{item.strTitle |faNum}}</th>

                <th class="text-dark">{{i+1|faNum}}</th>

            </tr>

        </tbody>

    </table>

</ng-container>

<ng-container *ngIf="type== '1-2'">

    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky p-2">

        <div>

            <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table-stop')"><i
                    class="fa fa-file-excel-o"></i>&nbsp; خروجی اکسل</button>

            <button class="btn btn-secondary" [routerLink]="[ '/stopMap/',Id+ '&'] "><i
                    class="fa fa-map-marker fa-lg"></i>&nbsp; نمایش همه بر روی نقشه </button>

        </div>

        <div class="">

            <span class="text-white"> تعداد : {{ reportData.length | faNum }} </span>

            <span class="mx-2 text-white"> سرجمع : {{ total_fDischargeValue.toLocaleString() + ' لیتر ' |faNum }} </span>

        </div>

    </div>

    <div class="border border-2 " style="max-height:85vh;overflow:auto">

        <table class="table mt-1 table-striped" id="excel-table-stop">
    
            <thead class="">
    
                <tr class=" text-center">
    
                    <th scope="col" class=""> آدرس </th>
    
                    <th scope="col" class=""> سرعت </th>
    
                    <th scope="col" class=""> مقدار تخلیه </th>
    
                    <th scope="col" class=""> ساعت پایان </th>
    
                    <th scope="col" class=""> ساعت شروع </th>
    
                    <th scope="col" class=""> تاریخ </th>
    
                    <th scope="col" class=""> موقعیت </th>
    
                    <th scope="col" class=""> # </th>
    
                </tr>
    
            </thead>
    
            <tbody>
    
                <tr class="dirI text-center " *ngFor="let item of reportData;let i=index">
    
                    <th class="text-dark">{{item.strAddress|faNum}}</th>
    
                    <th class="text-dark">{{item.iSpeed.toLocaleString()|faNum}}</th>
    
                    <th class="text-dark">{{item.fDischargeValue.toLocaleString() + ' لیتر ' |faNum}}</th>
    
                    <th class="text-dark">{{item.strETime.trim() |faNum}}</th>
    
                    <th class="text-dark">{{item.strSTime.trim() |faNum}}</th>
    
                    <th class="text-dark">{{item.strDate.trim() |faNum}}</th>
    
                    <td class="text-center"><i title="موقعیت" aria-hidden="true" class="fa fa-map-marker fa-lg bg-gray p-2 px-3 rounded text-danger pointer" (click)="showOnMap(item)"></i></td>
    
                    <th class="text-dark">{{i+1|faNum}}</th>
    
                </tr>
    
            </tbody>
    
            <tfoot>
                <tr class="col-12 text-center table-total-row bg-light-2">
                    <td></td>
                    <td></td>
                    <td> {{ total_fDischargeValue.toLocaleString() |faNum }} </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <th colspan="X"> مجموع </th>
                </tr>
    
            </tfoot>
    
        </table>

    </div>


</ng-container>

<div class="col-lg-12" *ngIf="type == 2">

    <div class="d-flex">

        <div class="px-2 pb-3">

            <button class="btn btn-success p-2" (click)="exportexcel( 'excel-table-active') "> خروجی اکسل </button>

        </div>

        <div class="px-2 pb-3">

            <button class="btn btn-primary p-2" (click)="recalculate_Distance()"> محاسبه مجدد </button>

        </div>

    </div>

    <div class="table-responsive table-striped dirI">
        <table class="table table-bordered" id="excel-table-active">
            <thead class="">
                <tr class="text-center f14">
                    <th scope="col" class=""># </th>
                    <th scope="col" class=""> نام خودرو </th>
                    <th scope="col" class="">تاریخ </th>
                    <th scope="col" class="">زمان شروع</th>
                    <th scope="col" class="">زمان پایان</th>
                    <th scope="col" class="">زمان کل</th>
                    <th scope="col" class="">زمان حرکت</th>
                    <th scope="col" class="">زمان توقف</th>
                    <th scope="col" class="">مصرف سوخت</th>
                    <th scope="col" class="">میزان پیمایش (km)</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer f12" *ngFor="let item of reportData;let i=index">
                    <th class="text-secondary">{{i+1}}</th>
                    <th class="text-secondary">{{item.strFullName}}</th>
                    <th class="text-secondary">{{item.strDate|faNum}}</th>
                    <th class="text-secondary">{{item.strSTime|faNum}}</th>
                    <th class="text-secondary">{{item.strETime|faNum}}</th>
                    <th class="text-secondary">{{item.strFunction|faNum}}</th>
                    <th class="text-secondary">{{item.strAbsoulatFunction|faNum}}</th>
                    <th class="text-secondary">{{item.strParkTime|faNum}}</th>
                    <th class="text-secondary">{{item.fGasPer100|faNum}}</th>
                    <th class="text-secondary dirI"><span>{{item.Distance|faNum}} </span></th>
                </tr>
            </tbody>
        </table>
    </div>

</div>

<div class="col-lg-12" *ngIf="polyganId && type==10">
    <div class="table-responsive table-striped dirI">
        <table class="table table-bordered" id="excel-table-area">
            <thead class="">
                <tr class="text-center f14">

                    <th scope="col" class="">نام محدوده </th>

                    <th scope="col" class=""> نام راننده </th>

                    <th scope="col" class=""> کد پرسنلی </th>

                    <th scope="col" class=""> پلاک </th>

                    <th scope="col" class="">تاریخ </th>
                    <th scope="col" class="">روز </th>
                    <th scope="col" class="">ساعت ورود</th>
                    <th scope="col" class="">ساعت خروج</th>
                    <th scope="col" class="">مدت حضور</th>
                    <th scope="col" class="">مدت حرکت </th>
                    <th scope="col" class="">مدت توقف</th>
                    <th scope="col" class="">پیمایش</th>
                </tr>
            </thead>

            <tbody>

                <tr class="text-center pointer f12" *ngFor="let item of areaData">

                    <th class="text-secondary">{{item.strTitle}}</th>

                    <th class="text-secondary">{{item.strFullName }}</th>

                    <th class="text-secondary">{{item?.strPersonnelID ? (item.strPersonnelID | faNum) : '' }}</th>

                    <th class="text-secondary">{{item.strVehicleNo | faNum }}</th>

                    <th class="text-secondary">{{item.strDate|faNum}}</th>

                    <th class="text-secondary">{{item.strDayName}}</th>

                    <th class="text-secondary">{{item.strStartTime|faNum}}</th>

                    <th class="text-secondary">{{item.strEndTime|faNum}}</th>

                    <th class="text-secondary">{{item.strPresentTime|faNum}}</th>

                    <th class="text-secondary">{{item.strMoveTime|faNum}}</th>

                    <th class="text-secondary">{{item.strStopTime|faNum}}</th>

                    <th class="text-secondary">{{item.fKmTotal|faNum}}</th>

                </tr>

            </tbody>

        </table>

    </div>

</div>

<div class="col-lg-12" *ngIf="type==9">
    <div class="table-responsive dirI">
        <table class="table table-bordered table-striped" id="excel-table-enterExitReport">
            <thead class="">
                <tr class="text-center f14">
                    <th scope="col" class="">نام محدوده </th>
                    <th scope="col" class="">تاریخ </th>

                    <th scope="col" class="">ساعت ورود</th>
                    <th scope="col" class="">ساعت خروج</th>
                    <th scope="col" class="">مدت حضور</th>
                    <th class="d-none" scope="col">عرض جغرافیایی</th>
                    <th class="d-none" scope="col">طول جغرافیایی</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer f12" *ngFor="let item of gpdioData"
                    (click)="exitAndEnterMap(item.iArrivalsAndDepartures)">
                    <th class="txt-navy">{{item.strTitle}}</th>
                    <th class="text-secondary">{{item.strDate|faNum}}</th>

                    <th class="text-success">{{item.strPresenceTime|faNum}}</th>
                    <th class="text-danger">{{item.strExitTime|faNum}}</th>
                    <th class="text-secondary">{{item.strTimeInGeoFance|faNum}}</th>
                    <td class="d-none">{{item.fDeparturesLat}}</td>
                    <td class="d-none">{{item.fDeparturesLon}}</td>

                </tr>
            </tbody>
        </table>
    </div>
</div>

<ng-container *ngIf="type==13">
    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky">
        <div>
            <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table-refueling')"><i
                    class="fa fa-file-excel-o"></i>&nbsp; خروجی اکسل</button>
            <button class="btn btn-secondary" [routerLink]="[ '/stopMap/',Id+ '÷'] "><i
                    class="fa fa-map-marker fa-lg"></i>&nbsp; جانمایی سوختگیری بر روی نقشه</button>
        </div>
    </div>
    <div class="table-responsive rounded-3  my-2" style="max-height: 85vh; overflow-y: auto;">
        <table class="table table-striped mt-1 dirI" id="excel-table-refueling">
            <thead class="">
                <tr class="text-center f14">
                    <th scope="col" class="">تاریخ </th>
                    <th scope="col" class="">ساعت </th>
                    <th scope="col" class="">سوخت (litre) </th>
                    <th scope="col" class="">هزینه (تومان) </th>
                    <th scope="col" class="">پیمایش (km) </th>
                    <th class="" scope="col">پیمایش نسبت به قبل (km) </th>
                    <th class="" scope="col">متوسط مصرف (litre/100) </th>
                    <th class="d-none" scope="col">حوزه خدمت </th>
                    <th class="d-none" scope="col">گروه </th>
                    <th class="d-none" scope="col">نوع </th>
                    <th class="d-none" scope="col">پلاک </th>
                    <th class="d-none" scope="col">نام راننده </th>
                    <th class="d-none" scope="col">عرض جغرافیایی</th>
                    <th class="d-none" scope="col">طول جغرافیایی</th>
                    <th class="d-none" scope="col">شماره موبایل راننده</th>

                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer hoverItem f14" *ngFor="let item of refuelingReport"
                    (click)="setRefueling(item.fLat,item.fLon,item.strFullName,item.strDate,item.strTime,item.fLiter,item.IDefKM)">
                    <th class="txt-navy">{{item.strDate|faNum}}</th>
                    <th class="text-dark">{{item.strTime|faNum}}</th>
                    <th class="text-dark">{{item.fLiter | faNum}}</th>
                    <th class="text-danger">{{getSeparatedValue(item.iCost)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iKm)}}</th>
                    <td class="">{{item.IDefKM|faNum}}</td>
                    <td class="">{{item.fConsumption|faNum}}</td>
                    <td class="d-none">{{item.strMobileDomain_strComment|faNum}}</td>
                    <td class="d-none">{{item.strMobileGroup_strComment}}</td>
                    <td class="d-none">{{item.strMobileType_strComment}}</td>
                    <td class="d-none">{{item.strVehicleNo|faNum}}</td>
                    <td class="d-none">{{item.strFullName}}</td>
                    <td class="d-none">{{item.fLat}}</td>
                    <td class="d-none">{{item.fLon}}</td>
                    <td class="d-none">{{item.strMobile|faNum}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr class="text-center">
                    <td>جمع</td>
                    <td>-</td>
                    <td>{{refuelingLitr | faNum}}</td>
                    <td>{{getSeparatedValue(refuelingCost)}}</td>
                    <td>-</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
            </tfoot>
        </table>
    </div>
</ng-container>

<div class="col-lg-12" *ngIf="polyganId && type==11">
    <div class="table-responsive dirI">
        <table class="table table-bordered  table-striped" id="excel-table-enterExit">
            <thead class="">
                <tr class="text-center f14">
                    <th scope="col" class="">نام محدوده </th>
                    <th scope="col" class="">تاریخ </th>

                    <th scope="col" class="">ساعت ورود</th>
                    <th scope="col" class="">ساعت خروج</th>
                    <th scope="col" class="">مدت حضور</th>
                    <th class="d-none" scope="col">عرض جغرافیایی</th>
                    <th class="d-none" scope="col">طول جغرافیایی</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer f12" *ngFor="let item of areaData"
                    (click)="exitAndEnterMap(item.iArrivalsAndDepartures)">
                    <th class="txt-navy">{{item.strTitle}}</th>
                    <th class="text-secondary">{{item.strDate|faNum}}</th>

                    <th class="text-success">{{item.strPresenceTime|faNum}}</th>
                    <th class="text-danger">{{item.strExitTime|faNum}}</th>
                    <th class="text-secondary">{{item.strTimeInGeoFance|faNum}}</th>
                    <td class="d-none">{{item.fDeparturesLat}}</td>
                    <td class="d-none">{{item.fDeparturesLon}}</td>

                </tr>
            </tbody>
        </table>
    </div>
</div>

<table class="table mt-1 table-striped table-striped" *ngIf="type==3" id="excel-table-err">
    <thead class="">
        <tr class="text-center">
            <th scope="col" class="">شرح تخلف</th>
            <th scope="col" class="">زمان </th>
            <th scope="col" class="">تاریخ </th>
            <th scope="col" class=" d-none">نام راننده </th>
            <th class="d-none" scope="col">عرض جغرافیایی</th>
            <th class="d-none" scope="col">طول جغرافیایی</th>

            <th scope="col" class=""># </th>
        </tr>
    </thead>
    <tbody>
        <tr class="text-center pointer" *ngFor="let item of reportData;let i=index"
            (click)="setJournal(item.fLat,item.fLon,item.strComment,item.strTime,item.strDate)">
            <th class="text-secondary">{{item.strComment}}</th>
            <th class="text-secondary">{{item.strTime|faNum}}</th>
            <th class="text-secondary">{{item.strDate|faNum}}</th>
            <th class="text-secondary d-none">{{item.strFullName}}</th>
            <td class="d-none">{{item.fLat}}</td>
            <td class="d-none">{{item.fLon}}</td>
            <th class="text-secondary">{{i+1}}</th>
        </tr>

    </tbody>
</table>

<ng-container *ngIf="type==4">
    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky"
        *ngIf="reportData?.length > 0">
        <div>
            <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table-Cost')"><i
                    class="fa fa-file-excel-o"></i>&nbsp; خروجی اکسل</button>
            <button printTitle="گزارش هزینه های تعمیرات خودرو" printSectionId="print-table-repairCost"
                class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i
                    class="fa fa-print"></i></button>
        </div>
        <p class="f18 text-white text-center dirI px-3 my-auto">جمع کل هزینه ها : <strong>{{getSeparatedValue(Total) |
                faNum}}</strong>
            تومان
    </div>
    <div class="table-responsive rounded-3  my-2" id="print-table-repairCost"
        style="max-height: 85vh; overflow-y: auto;">
        <table class="table mt-1 table-striped" id="excel-table-Cost">
            <thead class="">
                <tr class="text-center">
                    <th scope="col" class=" d-none"> توضیحات</th>
                    <th scope="col" class="">نام تعمیرکار</th>
                    <th scope="col" class="">موضوع</th>
                    <th scope="col" class="">هزینه (ریال)</th>
                    <th scope="col" class="">مسافت طی شده (km)</th>
                    <th scope="col" class="">تاریخ </th>
                    <th scope="col" class=""> کاربر ثبت کننده </th>
                    <th scope="col" class=""> فاکتور </th>
                    <th scope="col" class=""># </th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer" *ngFor="let item of reportData;let i=index">
                    <th class="text-dark d-none">{{item.strComment}}</th>
                    <th class="text-dark">{{item.strRepairman}}</th>
                    <th class="text-dark">{{item.strReason}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iTotalCost)}}</th>
                    <th class="text-dark">{{getSeparatedValue(item.iKM)}}</th>
                    <th class="text-dark">{{item.strDate | faNum}}</th>
                    <th class="text-dark">{{item.strUserSaved | faNum}}</th>
                    <th class="text-dark" (click)="showFactor(item)"><i class="fa fa-file-image-o fa-lg pointer"
                            aria-hidden="true"></i></th>
                    <th class="text-dark">{{i+1 | faNum}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<!-- گزارش درآمدها هر کاربر -->

<ng-container *ngIf="type==5">
    <div class="d-flex justify-content-between ps-4 align-items-center bg-th-blue border-top position-sticky"
        *ngIf="reportData?.length > 0">
        <div>
            <button class="btn btn-success mx-2 pointer" (click)="exportexcel('excel-table-earningInd')"><i
                    class="fa fa-file-excel-o"></i>&nbsp; خروجی اکسل</button>
            <button printTitle="گزارش هزینه های تعمیرات خودرو" printSectionId="print-table-earningInd"
                class="btn btn-secondary pointer" [useExistingCss]="true" ngxPrint>چاپ <i
                    class="fa fa-print"></i></button>
        </div>
        <p class="f18 text-white text-center dirI px-3 my-auto">جمع کل درآمد ها : <strong>{{getSeparatedValue(TotalL) |
                faNum}}</strong>
            تومان
    </div>
    <div class="table-responsive rounded-3" id="print-table-earningInd" style="max-height: 85vh; overflow-y: auto;">
        <table class="table mt-1 table-striped" id="excel-table-earningInd">
            <thead>
                <tr class="text-center">
                    <th scope="col" class=" d-none">نام راننده </th>
                    <th scope="col">توضیحات</th>
                    <th scope="col">مبلغ</th>
                    <th scope="col">تاریخ </th>
                    <th scope="col"># </th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center pointer" *ngFor="let item of reportData;let i=index">
                    <th class="text-secondary d-none">{{item.strFullName}}</th>
                    <th class="text-secondary">{{item.strComment}}</th>
                    <th class="text-secondary">{{getSeparatedValue(item.iAmount)}}</th>
                    <th class="text-secondary">{{item.strDate|faNum}}</th>
                    <th class="text-secondary">{{i+1 | faNum}}</th>
                </tr>
            </tbody>
        </table>
    </div>
</ng-container>

<!-- گزارش جزییات عملکرد خودرو براساس مسیر    -->

<!-- گزارش سرجمع عملکرد خودرو براساس مسیر  -->

<!-- گزارش سرجمع عملکرد راننده براساس مسیر  -->

<ng-container *ngIf="type == 21 || type == '21-1' || type == 22 || type == 23">

    <form [formGroup]="RouteReport_Model" class="col-12 row gx-0 gx-md-2 px-2 pt-md-2 gy-3 gy-md-0 dirI">

        <div class="col-12 col-md-3 position-relative">

            <label class="position-absolute bg-white" style="right: 12px;top: -12px;padding: 0 7px;">

                تاریخ شروع

            </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <div class="col-12 col-md-3 position-relative">

            <label class="position-absolute bg-white" style="right: 12px;top: -12px;padding: 0 7px;"> تاریخ پایان

            </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strEDate" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <div class="col-12 col-md-2">

            <select class="form-select dirI" formControlName="iRoute">

                <option class="text-secondary" value="-1"> مسیر </option>

                <option *ngFor="let item of list_Route" class="text-secondary" [value]="item.iRoute"> {{ item.strName }}
                </option>

            </select>

        </div>

        <div class="col-12 col-md-2">

            <select class="form-select dirI" formControlName="strUnitID">

                <option class="text-secondary" value="" selected> خودرو </option>

                <option *ngFor="let item of list_Car" class="text-secondary" [value]="item.strUnitID">

                    {{item.strFullName }}

                </option>

            </select>

        </div>

        <div class="col-12 col-md-2 d-flex justify-content-start align-items-center">

            <input type="checkbox" id="baseSchedule" formControlName="bSchedule">

            <label class="px-2" for="baseSchedule"> تنها موارد مطابق برنامه </label>

        </div>

        <div class="col-12 row gy-2 gy-md-0 gx-2 justify-content-end p-2 mt-1">

            <div class="col-12 col-md-1">

                <button class="col-12  btn btn-primary" (click)="Route_FunctionReport()">

                    جستجو

                </button>

            </div>

            <div class="d-none col-12 col-md-auto">

                <button class="col-12  btn btn-success" (click)="exportexcel('excel-table-reportCar-base-route')">

                    خروجی اکسل

                </button>

            </div>

            <ng-container *ngIf="type == 21 || type == '21-1'">

                <!-- تحلیل -->

                <div class="col-12 col-md-1">

                    <button class="col-12 btn btn-success" (click)="route_Analysis()"> تحلیل </button>

                </div>

                <!-- حذف تحلیل -->

                <div class="col-12 col-md-auto" *ngIf="type == 21">

                    <button class="col-12 btn btn-danger" (click)="route_Report_DeleteAll()"> حذف تحلیل </button>

                </div>

                <!-- گزارش عملکرد بر اساس مسیر -->

                <div class="col-12 col-md-auto">

                    <button class="col-12 btn btn-secondary" (click)="route_SummaryByDay()">

                        گزارش عملکرد بر اساس مسیر

                    </button>

                </div>

                <!-- فیش حقوق رانندگان  -->

                <div class="col-12 col-md-auto" *ngIf="type == 21">

                    <button class="col-12 btn btn-warning" (click)="route_SalarySummary()">

                        فیش حقوق رانندگان

                    </button>

                </div>

            </ng-container>

        </div>

        <div *ngIf="list_RouteReport.length" class="position-fixed row gx-2 p-2" style="bottom: 0;background:#00ADB5;">

            <span class="col-12 col-md-2 text-white">

                {{ type == 21 || type == '21-1' ? ' تعداد سفر ' : ' مرتبه مسیرها ' }} :

                {{ type == 21 || type == '21-1' ? ( list_RouteReport.length | faNum ) + ' مورد ' : ( totalCount | faNum
                ) + ' مورد ' }}

            </span>

            <span class="col-12 col-md-3 text-white"> زمان کل سفر :

                {{ totalTime.toLocaleString() + ' ساعت ' | faNum }}

            </span>

            <span class="col-12 col-md-3 text-white"> پیمایش کل :

                {{ totalLength.toLocaleString() + ' کیلومتر ' | faNum }}

            </span>

            <span *ngIf="type != '21-1'" class="col-12 col-md-3 text-white"> سرجمع هزینه :

                {{ totalPrice.toLocaleString() + ' ریال ' | faNum }}

            </span>

        </div>

        <ng-container>

            <div class="col-12 px-2 mt-3">

                <div class="w-100 bg-th-blue" *ngIf="list_RouteReport?.length > 0">

                    <div class="d-flex justify-content-start justify-content-md-around
                    
                        p-2 gap-2 gap-md-0 align-items-center flex-wrap dirI">

                        <div class="w-100 d-flex justify-content-end gap-2 align-items-center mt-2">

                            <button *ngIf="type != 23" printTitle="گزارش جزییات عملکرد "
                                printSectionId="print-table-reportCar-base-route-custom"
                                class="btn btn-secondary pointer no-print" [useExistingCss]="true" ngxPrint>

                                چاپ

                                <i class="fa fa-print"></i>

                            </button>

                            <button class="btn btn-success pointer no-print"
                                (click)="exportexcel('excel-table-reportCar-base-route')">

                                خروجی اکسل

                                <i class="fa fa-file-excel-o"></i>

                            </button>

                        </div>

                    </div>

                </div>

                <div class="w-100 p-2 my-2">

                    <input type="text" class="form-control" placeholder="جستجو کنید..."
                        (keyup)="filter_list_RouteReport($event.target)">

                </div>


            </div>

        </ng-container>

    </form>

    <div class="table-responsive dirI rounded-3 p-2 my-2" id="print-table-reportCar-base-route"
        style="max-height: 62.4vh; overflow-y: auto;">

        <table class="table table-striped dirI border border-2" id="excel-table-reportCar-base-route">

            <thead class="">

                <tr *ngIf="type == 21 || type == '21-1'" class="col-12 text-center">

                    <th scope="col" class=""> # </th>

                    <th scope="col" class=""> عملیات </th>

                    <th scope="col" class=""> نوع خودرو </th>

                    <th scope="col" class=""> مسیر </th>

                    <th scope="col" class=""> مقصد </th>

                    <th scope="col" class=""> مبدا </th>

                    <th scope="col" class=""> تاریخ </th>

                    <th scope="col" class=""> ساعت خروج از مبدا </th>

                    <th scope="col" class=""> نام راننده </th>

                    <th scope="col" class="" *ngIf="type != '21-1'"> هزینه </th>

                    <th scope="col" class=""> پلاک </th>

                    <th scope="col" class=""> نفرات </th>

                    <th scope="col" class=""> مدت حضور در مبدا </th>

                    <th scope="col" class=""> ساعت ورود به مقصد </th>

                    <th scope="col" class=""> مدت سفر </th>

                    <th scope="col" class=""> پیمایش </th>

                    <th scope="col" class=""> تعداد ایستگاه میانی </th>

                    <th scope="col" class=""> تعداد پرسنل سوار شده </th>

                    <th scope="col" class=""> مطابق برنامه </th>

                </tr>

                <tr *ngIf="type == 22" class="col-12 text-center">

                    <th scope="col" class=""> # </th>

                    <th scope="col" class=""> تاریخ </th>

                    <th scope="col" class=""> راننده </th>

                    <th scope="col" class=""> نوع خودرو </th>

                    <th scope="col" class=""> پلاک </th>

                    <th scope="col" class=""> نام مسیر </th>

                    <th scope="col" class=""> روز </th>

                    <th scope="col" class=""> تعداد مرتبه طی شده </th>

                    <th scope="col" class=""> هزینه </th>

                    <th scope="col" class=""> جمع مدت زمان سفر </th>

                    <th scope="col" class=""> جمع پیمایش طی مسیر </th>

                </tr>

                <tr *ngIf="type == 23" class="col-12 text-center">

                    <th scope="col" class=""> # </th>

                    <th scope="col" class=""> مسیر </th>

                    <th scope="col" class=""> مقصد </th>

                    <th scope="col" class=""> مبدا </th>

                    <th scope="col" class=""> نام راننده </th>

                    <th scope="col" class=""> پلاک </th>

                    <th scope="col" class=""> نوع خودرو </th>

                    <th scope="col" class=""> عملکرد </th>

                    <th scope="col" class=""> هزینه </th>

                </tr>

            </thead>

            <tbody>

                <ng-container *ngIf="type == 21 || type == '21-1'">

                    <tr class="col-12 text-center f14" style="vertical-align: middle;"
                        *ngFor="let item of list_RouteReport;let i=index">

                        <th class="text-dark">{{ i + 1 | faNum }}</th>

                        <td class="text-center ">

                            <div class="d-flex align-items-center">

                                <img title="مسیر" class="pointer" width="25" height="25"
                                    src="../../../assets/Img/road-map.png" (click)="openRoute2(item)">

                                <i *ngIf="type != '21-1'" title="حذف" style="font-size: 21px;"
                                    class="fa fa-trash mx-2 pointer text-danger" (click)="removeRoute(item)"></i>

                                <img title="ایستگاه های میانی" class="pointer" width="25" height="25"
                                    src="../../../assets/Img/bus-stop.png" (click)="intermediate_Station(item)">

                            </div>

                        </td>

                        <td scope="col" class=""> {{ item.strMobileType_strComment | faNum }} </td>

                        <td scope="col" class=""> {{ item.strRoute_strName }} </td>

                        <td scope="col" class=""> {{ item.strDestinationStationName }} </td>

                        <td scope="col" class=""> {{ item.strSourceStationName }} </td>

                        <td scope="col" class=""> {{ item.strDate | faNum }} </td>

                        <td scope="col" class=""> {{ item.strSourceETime | faNum }} </td>

                        <td scope="col" class=""> {{ item.strFullName | faNum }} </td>

                        <td scope="col" class="" *ngIf="type != '21-1'"> {{ item.iCost.toLocaleString() | faNum }} </td>

                        <td scope="col" class=""> {{ item.strVehicleNo | faNum }} </td>

                        <td scope="col" style="background-color:#e0f2fe ;">

                            <div class="d-flex justify-content-center align-items-center pointer" style="height: 45px;">

                                <i class="fa fa-info-circle fa-lg text-primary " style="font-size: 21px;"
                                    (click)="show_FunctionReport(item)"></i>

                            </div>

                        </td>

                        <td scope="col" class=""> {{ item.strSourceSTime | faNum }} </td>

                        <td scope="col" class=""> {{ item.strDestinationSTime | faNum }} </td>

                        <td scope="col" class=""> {{ item.strTime.toLocaleString() | faNum }} </td>

                        <td scope="col" class=""> {{ item.fLength.toLocaleString() + ' کیلومتر ' | faNum }} </td>

                        <td scope="col" class=""> {{ item.iStationPassed | faNum }} </td>

                        <td scope="col" class=""> {{ item.iPassengers | faNum }} </td>

                        <td scope="col" class=""> {{ item.bSchedule ? 'بله' : 'خیر' }} </td>

                        <!-- <td scope="col" class=""> {{ item.strDate | faNum }} </td>

                        <td scope="col" class=""> {{ item.strDayName | faNum }} </td>

                        <td scope="col" class=""> {{ item.strSourcePresence | faNum }} </td>

                        <td scope="col" class=""> {{ item.strDestinationETime | faNum }} </td>

                        <td scope="col" class=""> {{ item.strDestinationPresence | faNum }} </td>

                        <td scope="col" class=""> {{ item.fLength.toLocaleString() + ' کیلومتر ' | faNum }} </td> -->

                    </tr>

                </ng-container>

                <ng-container *ngIf="type == 22">

                    <tr class="col-12 text-center f14" *ngFor="let item of list_RouteReport;let i=index">

                        <th class="text-dark">{{ i + 1 | faNum }}</th>

                        <td scope="col" class=""> {{ item.strDate | faNum }} </td>

                        <td scope="col" class=""> {{ item.strFullName | faNum }} </td>

                        <td scope="col" class=""> {{ item.strMobileType_strComment | faNum }} </td>

                        <td scope="col" class=""> {{ item.strVehicleNo | faNum }} </td>

                        <td scope="col" class=""> {{ item.strRoute_strName }} </td>

                        <td scope="col" class=""> {{ item.strDayName }} </td>

                        <td scope="col" class=""> {{ item.iCount.toLocaleString() | faNum }} </td>

                        <td scope="col" class=""> {{ ( item.iCount * item.iCost ).toLocaleString() | faNum }} </td>

                        <td scope="col" class=""> {{ item.strTeme.toLocaleString() | faNum }} </td>

                        <td scope="col" class=""> {{ item.fLength.toLocaleString() | faNum }} </td>

                    </tr>

                </ng-container>

                <ng-container *ngIf="type == 23">

                    <tr class="col-12 text-center f14" *ngFor="let item of list_RouteReport;let i=index">

                        <th class="text-dark">{{ i + 1 | faNum }}</th>

                        <td scope="col" class=""> {{ item.strRoute_strName }} </td>

                        <td scope="col" class=""> {{ item.strDestinationStationName }} </td>

                        <td scope="col" class=""> {{ item.strSourceStationName }} </td>

                        <td scope="col" class=""> {{ item.strFullName }} </td>

                        <td scope="col" class=""> {{ item.strVehicleNo | faNum }} </td>

                        <td scope="col" class=""> {{ item.strMobileType_strComment }} </td>

                        <td scope="col" class=""> {{ item.iCount.toLocaleString() | faNum }} </td>

                        <td scope="col" class=""> {{ ( item.iCount * item.iCost ).toLocaleString() | faNum }} </td>

                    </tr>

                </ng-container>

            </tbody>

        </table>

    </div>

</ng-container>

<table class="table mt-1 table-striped" *ngIf="type==6" id="excel-table-income-cost">
    <thead class="">
        <tr class="text-center">


            <th scope="col" class="">جمع کل هزینه ها</th>
            <th scope="col" class="">جمع کل درآمد </th>


        </tr>
    </thead>
    <tbody>
        <tr class="text-center pointer">


            <th class="text-secondary">{{Total| number:'1.0':'en-US'}}</th>
            <th class="text-secondary">{{TotalL | number:'1.0':'en-US'}}</th>

        </tr>

    </tbody>
</table>

<div *ngIf="type==7" class="col-12 dirI mt-2">
    <div class=" col-6 ">
        <select class="form-select dirI " (change)="filterRadyabStatus($event.target)">
            <option value="-1">نمایش همه</option>
            <option value="متصل">متصل</option>
            <option value="خاموش">خاموش</option>
            <option value="قطع">قطع</option>
            <option value="حرکت">حرکت</option>
            <option value="متوقف">متوقف</option>
            <option value="واقعه">واقعه</option>
        </select>
    </div>

</div>

<table class="table mt-1 dirI table-striped" *ngIf="type==7 " id="excel-table-DeviceEvents">
    <thead class=" dirI ">
        <tr class="text-center ">

            <th scope="col " class=" "># </th>
            <th class="d-none" scope="col">عرض جغرافیایی</th>
            <th class="d-none" scope="col">طول جغرافیایی</th>

            <th scope="col " class="pointer" (click)="sortByDate()">تاریخ </th>
            <th scope="col " class=" ">ساعت </th>
            <th scope="col " class=" ">وضعیت</th>
            <th scope="col " class=" ">واقعه</th>
            <th scope="col " class="text-white d-none ">نام راننده</th>
            <th scope="col " class="text-white d-none ">پلاک وسیله</th>
            <th scope="col " class="text-white d-none ">نوع وسیله</th>
            <th scope="col " class="text-white d-none ">نام وسیله</th>
            <th scope="col " class="text-white d-none ">گروه</th>
            <th scope="col " class="text-white d-none ">حوزه خدمت</th>
            <th scope="col " class="text-white d-none ">توضیحات</th>


        </tr>
    </thead>
    <tbody>
        <tr class="text-center pointer dirI " *ngFor="let item of deviceEvent;let i=index "
            (click)="setJournal(item.fLat,item.fLon,item.strDeviceEventsType_strComment,item.strTime,item.strDate) ">
            <th class="text-secondary ">{{i+1}}</th>
            <td class="d-none">{{item.fLat}}</td>
            <td class="d-none">{{item.fLon}}</td>
            <th class="text-secondary ">{{item.strDate|faNum}}</th>
            <th class="text-secondary ">{{item.strTime|faNum}}</th>
            <th class="text-secondary ">{{item.strDeviceStatus_strComment}}</th>
            <th class="text-secondary ">{{item.strDeviceEventsType_strComment}}</th>
            <th class="text-secondary d-none ">{{item.strFullName}}</th>
            <th class="text-secondary d-none ">{{item.strVehicleNo|faNum}}</th>
            <th class="text-secondary d-none ">{{item.strMobileType_strComment}}</th>
            <th class="text-secondary d-none ">{{item.strGPSType_strComment}}</th>
            <th class="text-secondary d-none ">{{item.strMobileGroup_strComment}}</th>
            <th class="text-secondary d-none ">{{item.strMobileDomain_strComment}}</th>
            <th class="text-secondary d-none ">{{item.strComment}}</th>
        </tr>
    </tbody>
</table>

<div id="print-section1">
    <div class="row dirI">
        <div class="col-10 text-center align-items-center border">
            <p class="mt-2 fw-bold">
                {{loggedinUserName}}
            </p>
            <p>گزارش حقوق رانندگان از تاریخ {{dataAz | faNum}} تا تاریخ {{dataTa |faNum}}
            </p>
        </div>
        <div class="col-2 text-center align-items-center border">
            <p class="p-2">تاریخ تهیه</p>
            {{currentDate | faNum}}
        </div>
    </div>
    <div class="table-responsive table-striped dirI">
        <table class="table table-bordered">
            <thead>
                <tr class="text-center f12">
                    <th scope="col" class="">ردیف </th>
                    <th scope="col" class="">راننده </th>
                    <th scope="col" class="">شماره پرسنلی</th>
                    <th scope="col" class="">پلاک</th>
                    <th scope="col" class="">نوع خودرو</th>
                    <th scope="col" class="">حوزه خدمت</th>
                    <th scope="col" class="">جمع ساعت</th>
                    <th scope="col" class="">جمع پیمایش</th>
                    <th scope="col" class="">حقوق (ریال)</th>
                </tr>
            </thead>
            <tbody>
                <tr class="text-center f12" *ngFor="let item of riderSalery;let i=index">
                    <th class="text-secondary">{{i+1 | faNum}}</th>
                    <th class="text-primary">{{item.strFullName }}</th>
                    <th class="text-success">{{item.strPersonnelID |faNum}}</th>
                    <th class="text-secondary license-plate d-block"
                        style="font-family: 'bYekan'; color: #0400ff; height: auto; margin-top: .1rem;">
                        {{otherService.returnCorrectPlate(item.strVehicleNo) | faNum}}</th>
                    <th class="text-secondary">{{item.strGPSType_strComment | faNum}}</th>
                    <th class="text-secondary">{{item.strMobileDomain_strComment}}</th>
                    <th class="text-secondary">{{item.strTotalTime | faNum}}</th>
                    <th class="text-secondary">{{getSeparatedValue(item.fTotalKm)}}</th>
                    <th class="text-secondary">{{getSeparatedValue(item.iSalary)}}</th>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="d-flex justify-content-around mt-3 border">
        <span>حقوق کل: {{getSeparatedValue(summeryForRiderSalary.totalSalary)}} <small>ریال </small></span>
        <span>پیمایش کل: {{getSeparatedValue(summeryForRiderSalary.totalRide)}} <small>کیلومتر </small></span>
        <span>زمان کل: {{summeryForRiderSalary.totalTime | faNum}} <small>دقیقه </small></span>
    </div>

</div>

<div class="w-100 bg-th-blue position-sticky px-2" style="bottom: 0; " *ngIf="type == 2">

    <label class="text-start w-100 text-white py-2 d-flex justify-content-between dirI ">

        مجموع میزان فعالیت :

        <!-- <i class="fa fa-file-excel-o pointer me-3 "  (click)="exportexcel( 'excel-table-active') "></i> -->

    </label>

    <div class="d-flex justify-content-around flex-wrap mb-2 dirI ">

        <!-- <span class="text-white ">زمان کل : {{sTotalTime}} :{{mTotalTime}} :{{hTotalTime}}</span> -->

        <span class="text-white ">زمان کل : {{ format_Time(report_Obj?.iFunction) | faNum }} </span>

        <!-- <span class="text-white ">زمان توقف : {{sStopTime}} :{{mStopTime}} :{{hStopTime}}</span> -->

        <span class="text-white ">زمان توقف : {{ format_Time(report_Obj?.iParkTime) | faNum }} </span>

        <!-- <span class="text-white ">زمان حرکت : {{smoveTime}} :{{mmoveTime}} :{{hmoveTime}}</span> -->

        <span class="text-white ">زمان حرکت : {{ format_Time(report_Obj?.iAbsoulatFunction) | faNum }} </span>

        <!-- <span class="text-white ">میزان پیمایش : {{dictance | number}} کیلومتر</span> -->

        <span class="text-white ">میزان پیمایش : {{ report_Obj?.Distance.toLocaleString() | faNum }} کیلومتر</span>

        <!-- <span class="text-white ">مصرف سوخت : {{fuel}} لیتر</span> -->

        <span class="text-white ">مصرف سوخت : {{ report_Obj?.fGasPer100.toLocaleString() | faNum }} لیتر</span>

    </div>

</div>

<div class="w-100 bg-th-blue position-sticky " style="bottom: 0; " *ngIf="polyganId && type==10 ">
    <p class="f18 text-white text-center dirI d-flex justify-content-around ">
        <span>
            خروجی اکسل<i class=" fa fa-file-excel-o pointer " aria-hidden="true "
                (click)="exportexcel( 'excel-table-area') "></i>
        </span>
        <span class=" ">جمع کل پیمایش : {{pimayesh}}</span>
        <span class=" ">جمع کل مدت حضور : {{siPresentTime}}:{{siPresentTimem}}</span>
        <span class=" ">جمع کل مدت حرکت : {{siMoveTime}}:{{siMoveTimem}}</span>
        <span class=" ">جمع کل مدت توقف : {{siStopTime}}:{{siStopTimem}}</span>
    </p>


</div>

<div class="w-100 bg-primary position-sticky " style="bottom: 0; " *ngIf="polyganId &&type==11 ">
    <p class="f18 text-white text-center dirI d-flex justify-content-center ">
        <span>
            خروجی اکسل<i class=" fa fa-file-excel-o pointer me-3 " aria-hidden="true "
                (click)="exportexcel( 'excel-table-enterExit') "></i>
        </span>
    </p>
</div>

<div class=" bg-th-blue w-fit position-sticky rounded-3 mx-auto " style="bottom: 0; " *ngIf="type==9 ">
    <p class="f18 text-white mx-2 text-center dirI d-flex justify-content-center pointer "
        (click)="exportexcel( 'excel-table-enterExitReport') ">
        <span>
            خروجی اکسل<i class=" fa fa-file-excel-o " aria-hidden="true "></i>
        </span>
    </p>
</div>

<div *ngIf="type?.includes('15')" class="d-flex flex-wrap p-2">

    <ng-container *ngIf="!type?.includes('15-5')">

        <div id="test" class="w-100 mt-0 col-12 position-sticky " style="height: 37vh; ">
    
            <div class="position-absolute " id="map_tooltip" data-bs-html="true ">
    
            </div>
    
        </div>
        
    </ng-container>

    <div class="col-md-12 col-12 mb-5 justify-content-around d-flex row chart1 rounded shadow p-2">

        <div class="col-12">

            <canvas id="myChart" [ngStyle]="{'max-height': type?.includes('15-5') ? '98vh' : '42vh'}"></canvas>

            <button class="btn btn-danger px-4 m-2" (click)="resetZoom() "> حالت عادی </button>

        </div>

    </div>

</div>

<div class="w-fit mx-auto position-sticky mt-2 " style="bottom: 0; " *ngIf="type==3 ">
    <div class="d-flex justify-content-center py-2 ">
        <button class="btn btn-success mx-2 " [routerLink]="[ '/stopMap/',Id+ '*'] ">جانمایی وقایع بر روی
            نقشه</button>
        <i class="fa fa-file-excel-o bg-th-blue pointer fa-2x text-center text-white p-2 rounded-2 " title="خروجی اکسل "
            aria-hidden="true " (click)="exportexcel( 'excel-table-err') "></i>
    </div>


</div>

<div class=" position-sticky w-fit mx-auto rounded-3 " style="bottom: 0; " *ngIf="type==7 ">
    <p class="f18 text-center dirI mx-2 " *ngIf="deviceEvent ">

        <span class="bg-th-blue p-1 rounded-3 ">تعداد کل{{deviceEvent.length}}</span>
        <i class="fa fa-file-excel-o pointer bg-th-blue p-2 rounded-3 mx-2 " aria-hidden="true "
            (click)="exportexcel( 'excel-table-DeviceEvents') "></i>
        <button class="btn btn-success " [routerLink]="[ '/stopMap/',Id+ '-'] ">جانمایی وقایع بر روی نقشه</button>
    </p>
</div>

<div class=" p-1 rounded-3 w-fit mx-auto rounded-3 position-fixed bottom-0 r-0 " style="left: 0; " *ngIf="type==8 ">

    <p class="f18 text-white text-center dirI " *ngIf="gpdioData ">
        <span class="bg-th-blue p-1 rounded-3 ">تعداد کل{{gpdioData.length}}</span>
        <i class="fa fa-file-excel-o pointer pointer bg-th-blue p-2 rounded-3 mx-2 " aria-hidden="true "
            (click)="exportexcel( 'excel-table-radyab') "></i>
        <button class="btn btn-success " [routerLink]="[ '/stopMap/',Id+ '_'] ">جانمایی ورود بر روی نقشه</button>
    </p>


</div>

<div class="bg-th-blue position-sticky w-fit mx-auto rounded-3 " style="bottom: 0; " *ngIf="type==6 ">
    <p class="f18 text-success text-center dirI mx-3 " *ngIf="TotalL-Total>0">شما در این بازه : {{TotalL-Total |
        number:'1.0':'en-US'}} تومان سود داشته اید <i class="fa fa-file-excel-o  pointer " aria-hidden="true"
            (click)="exportexcel('excel-table-income-cost')"></i></p>
    <p class="f18 text-danger text-center dirI mx-3" *ngIf="TotalL-Total < 0">شما در این بازه : {{TotalL-Total |
        number:'1.0':'en-US'}} تومان ضرر کرده اید <i class="fa fa-file-excel-o  pointer " aria-hidden="true"
            (click)="exportexcel('excel-table-income-cost')"></i></p>
    <p class="f18 text-white text-center dirI mx-3" *ngIf="TotalL-Total==0">شما در این بازه : سودی نداشته اید </p>
</div>

<div class="modal fade" id="SaleryModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content ">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">ویرایش حقوق</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around dirI flex-wrap" [formGroup]="saleryEditForm">
                <div class=" col-6 mt-2">
                    <div class="col-11">
                        <label class="mb-2"> از ساعت *</label>

                        <div class="input-group clockpicker">
                            <input formControlName="strStartTime" type="text" class="form-control shadow bg-light"
                                value="00:00" id="Stime" readonly>
                            <span class="input-group-addon ">
                                <span class="glyphicon glyphicon-time"></span>
                            </span>
                        </div>

                    </div>

                </div>
                <div class=" col-6 mt-2">
                    <div class="col-11">

                        <label class="mb-2"> تا ساعت *</label>

                        <div class="input-group clockpicker">
                            <input formControlName="strEndTime" type="text" class="form-control shadow bg-light"
                                value="23:59" id="Etime" readonly>
                            <span class="input-group-addon">
                                <span class="glyphicon glyphicon-time"></span>
                            </span>
                        </div>
                    </div>

                </div>
                <div class=" col-6 mt-2" *ngIf="type!=16">
                    <div class="col-11">
                        <label class="mb-2">اضافه کار تشویقی (ساعت)</label>
                        <input type="number" class="form-control" placeholder="اضافه کار تشویقی"
                            formControlName="iEncouragOvertime">
                    </div>

                </div>
                <div class="col-6 mt-2" *ngIf="type!=16">
                    <div class="col-11">

                        <label class="mb-2">پیمایش تشویقی(Km)</label>

                        <input type="number" class="form-control" placeholder="پیمایش تشویقی(Km)"
                            formControlName="iIncentiveKm">
                    </div>

                </div>
                <div class="col-6 mt-2" *ngIf="type!=16">
                    <div class="col-11">

                        <label class="mb-2">ساعت سرویس </label>

                        <input type="number" class="form-control" placeholder="ساعت سرویس"
                            formControlName="siServiceCharge">
                    </div>

                </div>


            </div>
            <div class="modal-footer dirI">
                <button type="button" class="btn btn-warning" (click)="editSaleryModal()">ویرایش</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="edit-all-salery-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content ">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">ویرایش حقوق</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex justify-content-around dirI flex-wrap" [formGroup]="saleryEditAllForm">
                <div class="col-md-5 col-6">
                    <div class="col-11">



                        <div class="d-flex col-12">
                            <label for="editTimeS">ویرایش ساعت شروع</label>
                            <input type="checkbox" class="form-check" id="editTimeS">
                        </div>
                        <label class="mb-2"> از ساعت *</label>
                        <div class="input-group clockpicker d-flex flex-wrap">

                            <input formControlName="strStartTime" type="text" class="form-control shadow bg-light"
                                value="00:00" id="StimeAll" readonly>
                            <span class="input-group-addon ">
                                <span class="glyphicon glyphicon-time"></span>
                            </span>
                        </div>

                    </div>

                </div>
                <div class="col-md-5 col-6">
                    <div class="col-11">
                        <div class="d-flex col-12">
                            <label for="editTimeE">ویرایش ساعت پایان</label>
                            <input type="checkbox" class="form-check" id="editTimeE">
                        </div>
                        <label class="mb-2"> تا ساعت *</label>

                        <div class="input-group clockpicker">
                            <input formControlName="strEndTime" type="text" class="form-control shadow bg-light"
                                value="23:59" id="EtimeAll" readonly>
                            <span class="input-group-addon">
                                <span class="glyphicon glyphicon-time"></span>
                            </span>
                        </div>
                    </div>

                </div>



            </div>
            <div class="modal-footer dirI">
                <button type="button" class="btn btn-warning" (click)="editAllSaleryModal()">ویرایش</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="intermediate-Station" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content ">

            <div class="modal-header dirI">

                <h5 class="modal-title"> ایستگاه های میانی طی شده </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <table class="table table-striped dirI" id="intermediate-Station-table">

                    <thead class="">

                        <tr class="col-12 text-center">

                            <th scope="col" class=""> # </th>

                            <th scope="col" class=""> موقعیت ایستگاه </th>

                            <th scope="col" class=""> تاریخ </th>

                            <th scope="col" class=""> نام خودرو </th>

                            <th scope="col" class=""> کد ایستگاه </th>

                            <th scope="col" class=""> نام ایستگاه </th>

                            <th scope="col" class=""> ساعت ورود </th>

                            <th scope="col" class=""> ساعت خروج </th>

                            <th scope="col" class=""> مدت حضور </th>

                            <th scope="col" class=""> تعداد مسافر سوار شده </th>

                            <th scope="col" class=""> تعداد مسافر پیاده شده </th>

                            <th scope="col" class=""> تخلف حضور </th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr class="col-12 text-center f14" *ngFor="let item of list_Intermediate_Station;let i=index">

                            <th class="text-dark">{{ i + 1 | faNum }}</th>

                            <td class="text-center pointer " (click)="showStation_Map(item)">

                                <i class="fa fa-map-marker fa-lg text-dark"> </i>

                            </td>

                            <td scope="col" class=""> {{ item?.strDate ? item.strDate : 'نامشخص' | faNum }} </td>

                            <td scope="col" class=""> {{ item.strFullName | faNum }} </td>

                            <td scope="col" class=""> {{ item.iRoute_Station | faNum }} </td>

                            <td scope="col" class=""> {{ item.strName | faNum }} </td>

                            <td scope="col" class=""> {{ item.strSTime | faNum }} </td>

                            <td scope="col" class=""> {{ item.strETime | faNum }} </td>

                            <td scope="col" class=""> {{ item.strPresence | faNum }} </td>

                            <td scope="col" class=""> {{ item.iOnboard | faNum }} </td>

                            <td scope="col" class=""> {{ item.iDisembarked | faNum }} </td>

                            <td scope="col" class=""> {{ item.bViolation ? ' بله ' : ' خیر ' }} </td>

                        </tr>

                    </tbody>

                </table>

            </div>

        </div>

    </div>

</div>

<!-- چاپ گزارش جزییات عملکرد خودرو براساس مسیر -->

<!-- چاپ گزارش سرجمع عملکرد خودرو براساس مسیر -->

<div class="d-none table-responsive dirI rounded-3 p-2 my-2" id="print-table-reportCar-base-route-custom">

    <table class=" table table-striped dirI border border-2">

        <thead class="table-header">

            <tr class="col-12 text-center">

                <ng-container *ngIf="list_RouteReport[0]?.strSourcePresence">

                    <th scope="col" class=""> نوع خودرو </th>

                    <th scope="col" class=""> مقصد </th>

                    <th scope="col" class=""> مبدا </th>

                    <th scope="col" class=""> ساعت خروج از مبدا </th>

                    <th scope="col" class=""> راننده </th>

                    <th scope="col" class=""> نفرات </th>

                    <th scope="col" class=""> هزینه </th>

                </ng-container>

                <ng-container *ngIf="!list_RouteReport[0]?.strSourcePresence">

                    <th scope="col" class=""> تاریخ </th>

                    <th scope="col" class=""> روز </th>

                    <th scope="col" class=""> پلاک </th>

                    <th scope="col" class=""> تعداد مرتبه طی شده </th>

                    <th scope="col" class=""> جمع زمان سفر </th>

                    <th scope="col" class=""> جمع پیمایش مسیر </th>

                </ng-container>

            </tr>

        </thead>

        <tbody>

            <ng-container>

                <tr class="col-12 text-center f14" *ngFor="let item of list_RouteReport;">

                    <ng-container *ngIf="list_RouteReport[0]?.strSourcePresence">

                        <td scope="col" class=""> {{ item.strMobileType_strComment | faNum }} </td>

                        <td scope="col" class=""> {{ item.strDestinationStationName | faNum }} </td>

                        <td scope="col" class=""> {{ item.strSourceStationName | faNum }} </td>

                        <td scope="col" class=""> {{ item.strSourceETime | faNum }} </td>

                        <td scope="col" class=""> {{ item.strFullName | faNum }} </td>

                        <td scope="col" class=""> - - - - - </td>

                        <td scope="col" class=""> {{ item.iCost.toLocaleString() | faNum }} </td>


                    </ng-container>

                    <ng-container *ngIf="!list_RouteReport[0]?.strSourcePresence">

                        <td scope="col" class=""> {{ item.strDate | faNum }} </td>

                        <td scope="col" class=""> {{ item.strDayName | faNum }} </td>

                        <td scope="col" class=""> {{ item.strVehicleNo | faNum }} </td>

                        <td scope="col" class=""> {{ item.iCount.toLocaleString() | faNum }} </td>

                        <td scope="col" class=""> {{ item.strTeme.toLocaleString() | faNum }} </td>

                        <td scope="col" class=""> {{ item.fLength.toLocaleString() | faNum }} </td>

                    </ng-container>

                </tr>

                <ng-container *ngIf="list_RouteReport[0]?.strSourcePresence">

                    <tr class="col-12 text-center f14">

                        <td scope="col" colspan="3">

                            <span class="fw-bold">

                                تعداد سفر : {{ ( list_RouteReport.length | faNum ) + ' مورد ' }}

                            </span>

                        </td>

                        <td scope="col" colspan="4">

                            <span class="fw-bold">

                                سرجمع هزینه : {{ totalPrice.toLocaleString() + ' تومان ' | faNum }}

                            </span>

                        </td>

                    </tr>

                </ng-container>

            </ng-container>

        </tbody>


    </table>

</div>

<!--  مدال نفرات گزارش جزییات عملکرد خودرو براساس مسیر-->

<div class="modal fade" id="Func_Passenger_Modal" tabindex="-1" aria-labelledby="" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content ">

            <div class="modal-header dirI">

                <h5 class="modal-title"> نفرات </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div dir="rtl" class="w-100 p-2 my-2">

                    <input type="text" class="form-control" placeholder="جستجو کنید..."
                        (keyup)="filter_list_Passenger($event.target)">

                </div>

                <table class="table table-striped dirI" id="Func_Passenger_Modal-table">

                    <thead class="">

                        <tr class="col-12 text-center">

                            <th scope="col" class=""> # </th>

                            <th scope="col" class=""> عملیات </th>

                            <th scope="col" class=""> نام, نام خانوادگی </th>

                            <th scope="col" class=""> جایگاه سازمانی </th>

                            <th scope="col" class=""> حوزه خدمت </th>

                            <th scope="col" class=""> تاریخ </th>

                            <th scope="col" class=""> ساعت </th>

                            <th scope="col" class=""> نام ایستگاه </th>

                            <th scope="col" class=""> پلاک خودرو </th>

                        </tr>

                    </thead>

                    <tbody>

                        <tr class="col-12 text-center f14" *ngFor="let item of list_ReportPassenger;let i=index">

                            <th class="text-dark"> {{ i + 1 | faNum }}</th>

                            <td class="text-center pointer ">

                                <i class="fa fa-map-marker mx-2 fa-lg text-dark" (click)="showStation_Map(item)"> </i>

                                <i class="fa fa-eye fa-lg text-dark"> </i>

                            </td>

                            <td scope="col" class=""> {{ item.strPassenger_FullName | faNum }} </td>

                            <td scope="col" class=""> {{ item.strUserManager_Chart_strComment | faNum }} </td>

                            <td scope="col" class=""> {{ item.strMobileDomain_strComment | faNum }} </td>

                            <td scope="col" class=""> {{ item.strDate | faNum }} </td>

                            <td scope="col" class=""> {{ item.strTime | faNum }} </td>

                            <td scope="col" class=""> {{ item.strName == null ? ' - - - ' : item.strName | faNum }}
                            </td>

                            <td scope="col" class=""> {{ item.strVehicleNo ? (item?.strVehicleNo | faNum) : ' - - - ' }}
                            </td>

                        </tr>

                    </tbody>

                </table>

            </div>

        </div>

    </div>

</div>

<!-- گزارش عملکرد براساس مسیر  -->

<div class="modal fade" id="SummaryByDay_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-fullscreen">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> گزارش عملکرد براساس مسیر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <span> تعداد روز : <b>{{ iDays | faNum }}</b> </span>

                <span class="mx-2"> تعداد کل مسیر : <b>{{ lst_Route_SummaryByDay.length | faNum }}</b> </span>

                <div class="table-responsive dirI rounded-3 p-2 my-2" id="print-SummaryByDay_Modal"
                    style="max-height: 62.4vh; overflow-y: auto;">

                    <table class="table table-striped dirI border border-2" id="excel-SummaryByDay_Modal">

                        <thead class="">

                            <tr class="col-12 text-center">

                                <th *ngFor="let key of lstHeaders;">

                                    {{ key | faNum }}

                                </th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr *ngFor="let item of lstRowValues;let i=index" class="col-12 text-center f14"
                                style="vertical-align: middle;">

                                <ng-container *ngFor="let value of item ">

                                    <td class="">

                                        {{ value | faNum }}

                                    </td>

                                </ng-container>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- صورت حساب رانندگان -->

<div class="modal fade" id="SalarySummary_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-fullscreen">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> صورت حساب رانندگان </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="row gx-0 gy-0 justify-content-between px-2">

                    <div class="col-12 col-md-6 row -gx-0 -gy-0">

                        <span class="col-12 col-md-auto"> تعداد کل : {{ iCount | faNum }} </span>

                        <span class="col-12 col-md-auto"> مبلغ کل : {{ iAmount | number:'1.0-0' | faNum }} ریال </span>


                    </div>

                    <div class="col-12 col-md-6 row gx-0 -gy-0 justify-content-end">

                        <!-- چاپ -->

                        <div class="col-12 col-md-auto">

                            <button printTitle="صورت حساب رانندگان" printSectionId="print-table-salary_driver"
                                class="btn btn-secondary pointer w-100" [useExistingCss]="true" ngxPrint>

                                <i class="fa fa-print"></i>&nbsp;

                                چاپ

                            </button>

                        </div>

                        <!-- خروجی اکسل -->

                        <div class="col-12 col-md-auto">

                            <button class="btn btn-success mx-2 pointer w-100"
                                (click)="exportexcel('SalarySummary_excel-list')">

                                <i class="fa fa-file-excel-o"></i>

                                &nbsp; خروجی اکسل

                            </button>

                        </div>

                    </div>

                </div>

                <div class="border border-2 mt-3 p-2">

                    <input type="text" class="w-100 form-control" placeholder="جستجو کنید ..."
                        (keyup)="filter_list_BySalary($event.target)">

                    <div class="section border border-2 mt-2 overflow-auto" id="print-table-salary_driver">

                        <table class="table table-striped bg-white mt-1 dirI" id="SalarySummary_excel-list"
                            style="max-height: 62.4vh; overflow-y: auto;">

                            <thead>

                                <tr class="text-center">

                                    <th scope="col"> # </th>

                                    <th scope="col"> نام راننده </th>

                                    <th scope="col"> مسیر </th>

                                    <th scope="col"> نوع خودرو </th>

                                    <th scope="col"> از تاریخ </th>

                                    <th scope="col"> تا تاریخ </th>

                                    <th scope="col"> تعداد </th>

                                    <th scope="col"> کرایه </th>

                                    <th scope="col"> مبلغ کارکرد </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="f14 text-center" *ngFor="let item of lst_SalarySummary;let i=index">

                                    <th> {{ i + 1 | faNum}} </th>

                                    <td> {{ item.strFullName | faNum }} </td>

                                    <td> {{ item.strRoute_strName | faNum }} </td>

                                    <td> {{ item.strMobileType_strComment | faNum }} </td>

                                    <td> {{ item.strSDate | faNum }} </td>

                                    <td> {{ item.strEDate | faNum }} </td>

                                    <td> {{ item.iCount | faNum }} </td>

                                    <td> {{ item.iCost | number:'1.0-0' | faNum }} </td>

                                    <td> {{ item.iAmount | number:'1.0-0' | faNum }} </td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>